import { Translations } from './types';

export const translationsDe: Translations = {
  landing: {
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    hero: {
      eyebrow: 'Willkommen',
      title: 'Lassen Sie uns Sie einrichten',
      subhead:
        'Die Erstellung Ihres Data-Mission-Kontos dauert etwa zwei Minuten. Hier erfahren Sie, was Sie erwartet, bevor Sie mit der Registrierung beginnen, damit nichts überraschend kommt.',
      illustrationAlt: 'Illustration einer Hand, die einen Stecker mit einer Wolke verbindet',
    },
    steps: {
      stepLabel: 'Schritt',
      step1Title: 'Geben Sie Ihre E-Mail-Adresse ein',
      step1Body:
        'Wir verwenden sie als Ihren Benutzernamen und senden den nächsten Schritt dorthin. Verwenden Sie nach Möglichkeit eine geschäftliche E-Mail-Adresse, da dieses Konto mit Ihrem Team verknüpft wird.',
      step2Title: 'Bestätigen Sie mit einem Einmalcode',
      step2Body:
        'Suchen Sie in Ihrem Posteingang nach einem sechsstelligen Code von uns und fügen Sie ihn auf der Registrierungsseite ein. Es dauert nur wenige Sekunden und bestätigt, dass die E-Mail-Adresse Ihnen gehört.',
      step3Title: 'Legen Sie Ihr Passwort fest',
      step3Body:
        'Wählen Sie ein Passwort und geben Sie einige grundlegende Informationen zu sich ein. Dies ist das Konto, mit dem Sie sich künftig anmelden werden.',
      step4Title: 'Schließen Sie das geführte Onboarding ab',
      step4Body:
        'Sobald Sie angemeldet sind, führen wir Sie Schritt für Schritt durch die Anbindung Ihrer ersten Quelle und die Einrichtung Ihrer ersten Synchronisation. Keine Suche in der Dokumentation nötig.',
    },
    cta: {
      headline: 'Bereit, wenn Sie es sind',
      subhead:
        'Die Registrierungsseite wird von Microsoft Entra gehostet. Sie sieht aus wie eine Anmeldeseite, aber Sie sind genau richtig.',
      signUpEmail: 'Mit E-Mail registrieren',
      signUpMicrosoft: 'Mit Microsoft registrieren',
      microsoftIconAlt: 'Microsoft-Logo',
    },
    signInCard: {
      text: 'Sie haben bereits ein Konto?',
      link: 'Stattdessen anmelden ›',
    },
    footer: {
      privacyPolicy: 'Datenschutzerklärung',
      termsOfUse: 'Nutzungsbedingungen',
    },
  },
  support: {
    title: 'Support',
    description: 'Erhalten Sie Hilfe zu Data Mission Sync, kontaktieren Sie Ihren Partner und verfolgen Sie Ihre Support-Tickets.',
    unavailable: 'Der Support ist vorübergehend nicht verfügbar. Bitte versuchen Sie es in einigen Minuten erneut.',
    helpCenter: {
      title: 'Hilfe-Center',
      description: 'Durchsuchen Sie Anleitungen und Antworten auf häufige Fragen.',
      open: 'Hilfe-Center öffnen',
    },
    partner: {
      title: 'Ihr Partner',
      description: 'Ihre Organisation wird von diesem Partner betreut.',
      logoAlt: 'Logo von {name}',
      email: 'E-Mail',
      phone: 'Telefon',
      website: 'Website',
      location: 'Standort',
    },
    visibility: {
      title: 'Sichtbarkeit',
      withPartner: 'Alle Benutzer dieser Organisation können Support-Tickets einsehen und kommentieren, einschließlich Ihres Partners {name}.',
      withoutPartner: 'Alle Benutzer dieser Organisation können Support-Tickets einsehen und kommentieren. Wenn Ihnen ein Partner zugewiesen ist, kann er das ebenfalls.',
    },
    status: {
      WaitingOnYou: 'Wartet auf Sie',
      WaitingOnYouTooltip: 'Der Support hat geantwortet und benötigt etwas von Ihnen. Mit Ihrer Antwort geht das Ticket an ihn zurück.',
      Open: 'Offen',
      OpenTooltip: 'Wartet auf Bearbeitung durch das Support-Team.',
      InProgress: 'In Bearbeitung',
      InProgressTooltip: 'Das Support-Team arbeitet daran.',
      Resolved: 'Gelöst',
      ResolvedTooltip: 'Das Support-Team hat es gelöst. Fügen Sie einen Kommentar hinzu, wenn Sie weiterhin Hilfe benötigen.',
      Closed: 'Geschlossen',
      ClosedTooltip: 'Das Ticket ist geschlossen. Sie können weiterhin einen Kommentar hinzufügen.',
    },
    person: {
      you: 'Sie',
      teamMember: 'Teammitglied',
      supportTeam: 'Support-Team',
      aiSummary: 'KI-Zusammenfassung',
      supportRole: 'Support',
    },
    waitingBanner: {
      titleOne: 'Der Support wartet bei 1 Ticket auf Ihre Antwort',
      titleOther: 'Der Support wartet bei {count} Tickets auf Ihre Antwort',
      body: 'Antworten Sie, damit es weitergeht.',
      action: 'Tickets anzeigen',
    },
    tickets: {
      title: 'Support-Tickets',
      description: 'Alle Tickets Ihrer Organisation, von jedem Mitglied Ihres Teams.',
      newTicket: 'Neues Ticket',
      loading: 'Tickets werden geladen...',
      loadFailed: 'Support-Tickets konnten nicht geladen werden',
      emptyTitle: 'Noch keine Support-Tickets',
      emptyBody: 'Erstellen Sie ein Ticket, wenn Sie Hilfe vom Support-Team benötigen, zum Beispiel bei einer fehlgeschlagenen Synchronisierung oder einer Frage zu Ihrer Einrichtung. Alle Mitglieder Ihrer Organisation können es hier sehen und den Fortschritt verfolgen.',
      tabsLabel: 'Tickets filtern',
      tabs: {
        open: 'Offen',
        needsReply: 'Ihre Antwort nötig',
        closed: 'Geschlossen',
      },
      emptyTab: {
        open: 'Keine offenen Tickets. Erstellen Sie ein neues Ticket, wenn Sie Hilfe benötigen.',
        needsReply: 'Im Moment wartet nichts auf Ihre Antwort.',
        closed: 'Noch keine geschlossenen Tickets.',
      },
      previous: 'Zurück',
      next: 'Weiter',
      pageOf: 'Seite {page} von {totalPages}',
      openedBy: 'Erstellt von {name}',
      commentCount: '{count} Kommentare',
      attachmentCount: '{count} Dateien',
      noActivity: 'Noch keine Antworten',
      columns: {
        ticket: 'Ticket',
        type: 'Art',
        category: 'Kategorie',
        status: 'Status',
        lastActivity: 'Letzte Aktivität',
      },
      noCategory: '—',
      types: {
        Support: 'Support',
        DataWrangler: 'Data Wrangler',
      },
    },
    newTicket: {
      title: 'Neues Support-Ticket',
      description: 'Beschreiben Sie, wobei Sie Hilfe benötigen. Wir antworten im Ticket.',
      back: 'Zurück zum Support',
      typeLabel: 'Art der Hilfe',
      typeSupport: 'Support erhalten',
      typeSupportDescription: 'Eine Frage oder ein Problem mit Data Mission Sync. Fehler verbrauchen nie Stunden.',
      typeWrangler: 'Data Wrangler',
      typeWranglerDescription: 'Praktische Hilfe bei Ihrer Einrichtung, Konfiguration oder Ihren Daten, mit den Stunden Ihrer Organisation.',
      wranglerPartnerNote: 'Dienstleistungen werden zuerst Ihrem Partner {name} angeboten.',
      wranglerHoursNote: 'Sie können die Anfrage unabhängig vom Stundenguthaben Ihrer Organisation senden.',
      titleLabel: 'Titel',
      titlePlaceholder: 'Eine kurze Zusammenfassung des Problems',
      titleRequired: 'Titel ist erforderlich',
      titleTooLong: 'Der Titel darf höchstens {max} Zeichen lang sein',
      descriptionLabel: 'Beschreibung',
      descriptionPlaceholder: 'Was passiert ist, was Sie erwartet haben und wie es sich reproduzieren lässt',
      descriptionHint: 'Geben Sie den Profilnamen, die Tabelle und den ungefähren Beginn an. Screenshots und Fehlerdetails helfen am meisten.',
      descriptionRequired: 'Beschreibung ist erforderlich',
      attachmentsLabel: 'Anhänge (optional)',
      attachmentsHint: 'Bis zu {size} pro Datei.',
      attachmentsAllowedHint: 'Erlaubte Dateitypen: {types}.',
      attachmentsBlockedHint: 'Diese Dateitypen können nicht angehängt werden: {types}.',
      removeFile: '{name} entfernen',
      submit: 'Ticket erstellen',
      submitting: 'Wird erstellt...',
      cancel: 'Abbrechen',
      created: 'Support-Ticket erstellt',
      createFailed: 'Support-Ticket konnte nicht erstellt werden',
      uploadsFailed: 'Das Ticket wurde erstellt, aber diese Dateien konnten nicht hochgeladen werden: {files}. Sie können es im Ticket erneut versuchen.',
    },
    coverage: {
      title: 'Wer hilft wobei',
      supportHeading: 'Data Rodeo Support',
      included: 'Inbegriffen',
      supportBugs: 'Fehler in Data Mission Sync. Fehler verbrauchen nie Stunden.',
      supportProduct: 'Wie das Produkt und seine Funktionen funktionieren.',
      supportKnowledgeBase: 'Die Wissensdatenbank und Videobibliothek, in Ihrem Abonnement enthalten.',
      partnerTag: 'Ihr Partner',
      partnerSetup: 'Ihre Konfiguration und Einrichtung.',
      partnerProcesses: 'Ihre Geschäftsprozesse und alles, was rund um Data Mission Sync aufgebaut ist.',
      partnerServices: 'Dienstleistungen und Projektarbeit. Diese werden zuerst Ihrem Partner angeboten.',
      contactPartner: '{name} kontaktieren',
      wranglerHeading: 'Data Wrangler Services',
      paidHours: 'Kostenpflichtige Stunden',
      wranglerSetup: 'Ihre Konfiguration, Einrichtung und Prozesse rund um Data Mission Sync.',
      wranglerHandsOn: 'Praktische Hilfe von einem Data Wrangler aus Ihren gekauften Stunden. Data Wrangler Stunden sind immer kostenpflichtig.',
      knowledgeBase: 'Wissensdatenbank durchsuchen',
    },
    nextSteps: {
      title: 'Was nach dem Absenden passiert',
      aiSummary: 'Wir fügen oben in Ihrem Ticket eine KI-Zusammenfassung hinzu, oft mit hilfreichen Artikeln.',
      bugs: 'Mögliche Fehler gehen direkt an unser Entwicklungsteam.',
      partner: 'Bei Einrichtung und Konfiguration kann {name} helfen.',
      wrangler: 'Bei Einrichtung und Konfiguration kann ein Data Wrangler mit den Stunden Ihrer Organisation helfen.',
      waiting: 'Wenn wir etwas von Ihnen benötigen, zeigt das Ticket „Wartet auf Sie“.',
    },
    hours: {
      title: 'Data Wrangler Stunden',
      scope: 'Für Ihre gesamte Organisation. Die für ein Ticket aufgewendete Zeit wird in dessen Unterhaltung festgehalten.',
      available: 'Verfügbar',
      spent: 'Bisher verbraucht',
      assigned: 'Insgesamt gekauft',
      value: '{hours} Std.',
      buy: 'Stunden kaufen',
      askAdmin: 'Bitten Sie einen Administrator, Stunden zu kaufen.',
      loadFailed: 'Stunden konnten nicht geladen werden.',
    },
    buyHours: {
      title: 'Data Wrangler Stunden kaufen',
      description: 'Wählen Sie ein Paket. Sie schließen den Kauf auf einer sicheren Stripe-Seite ab, und die Stunden werden Ihrer Organisation nach Zahlungseingang gutgeschrieben.',
      loading: 'Pakete werden geladen...',
      loadFailed: 'Pakete konnten nicht geladen werden.',
      empty: 'Derzeit sind keine Stundenpakete verfügbar.',
      packageHours: '{hours} Stunden',
      checkout: 'Weiter zur Zahlung',
      redirecting: 'Zahlung wird geöffnet...',
      checkoutFailed: 'Die Zahlungsseite konnte nicht geöffnet werden.',
      cancel: 'Abbrechen',
    },
    detail: {
      back: 'Zurück zum Support',
      loadFailed: 'Support-Ticket konnte nicht geladen werden',
      openedBy: 'Erstellt von',
      created: 'Erstellt',
      updated: 'Zuletzt aktualisiert',
      resolved: 'Gelöst',
      detailsTitle: 'Details',
      statusLabel: 'Status',
      type: 'Art der Hilfe',
      resolutionCategory: 'Lösungskategorie',
      notCategorized: 'Noch nicht kategorisiert',
      descriptionTitle: 'Beschreibung',
      attachmentsTitle: 'Anhänge',
      noAttachments: 'Keine Dateien angehängt.',
      addFiles: 'Dateien hinzufügen',
      uploading: 'Wird hochgeladen...',
      uploaded: 'Datei hochgeladen',
      uploadFailed: '{name} konnte nicht hochgeladen werden',
      uploadedBy: 'Hochgeladen von {name}',
      download: 'Herunterladen',
      downloadFailed: 'Datei konnte nicht heruntergeladen werden',
      scanning: 'Wird geprüft',
      scanningTooltip: 'Die Datei wird auf Viren geprüft und ist in Kürze verfügbar.',
      unavailable: 'Nicht verfügbar',
      unavailableTooltip: 'Die Datei hat die Virenprüfung nicht bestanden und kann nicht heruntergeladen werden.',
      conversationTitle: 'Unterhaltung',
      replyCount: '{count} Antworten · neueste zuerst',
      noComments: 'Noch keine Kommentare.',
      yourTurn: 'Sie sind dran',
      yourTurnBody: 'Der Support wartet auf Ihre Antwort, damit es mit diesem Ticket weitergeht.',
      commentLabel: 'Dem Support antworten',
      commentPlaceholder: 'Schreiben Sie eine Antwort an das Support-Team',
      commentRequired: 'Kommentar ist erforderlich',
      commentTooLong: 'Der Kommentar darf höchstens {max} Zeichen lang sein',
      attachToReply: 'Dateien anhängen',
      postComment: 'Antwort senden',
      posting: 'Wird gesendet...',
      commentFailed: 'Kommentar konnte nicht gesendet werden',
      showMore: 'Ganze Antwort anzeigen',
      showLess: 'Weniger anzeigen',
      openImage: '{name} in voller Größe öffnen',
      imageViewerTitle: 'Anhangsvorschau',
      previousImage: 'Vorheriges Bild',
      nextImage: 'Nächstes Bild',
      imageCount: '{index} von {total}',
    },
    attachmentErrors: {
      tooLarge: '{name} ist größer als {size}.',
      typeNotAllowed: '{name} ist kein erlaubter Dateityp.',
      nameTooLong: 'Der Name von {name} ist länger als {max} Zeichen.',
    },
  },
  runs: {
    runStates: {
      Completed: 'Abgeschlossen',
      CompletedTooltip:
        'Synchronisierung erfolgreich abgeschlossen. Alle Daten wurden aus der Quelle extrahiert und in die Zieldatenbank geladen.',
      Failed: 'Fehlgeschlagen',
      FailedTooltip:
        'Synchronisierung ist auf einen Fehler gestoßen und konnte nicht abgeschlossen werden. Klicken Sie auf die Zeile, um detaillierte Fehlerinformationen anzuzeigen.',
      Extracting: 'Extrahiere',
      ExtractingTooltip: 'Daten werden derzeit aus der Quelltabelle extrahiert.',
      Loading: 'Lade',
      LoadingTooltip: 'Daten werden derzeit in die Zieldatenbank geladen.',
      WaitingForTargetLease: 'Warte auf Ziel-Lease',
      WaitingForTargetLeaseTooltip:
        'Wartet darauf, eine Sperre auf die Zieldatenbank zu erhalten, bevor das Laden beginnen kann.',
      WaitingForSourceCapacity: 'Warte auf Quellkapazität',
      WaitingForSourceCapacityTooltip:
        'Diese Dataverse-Umgebung hat ihr Limit an gleichzeitigen Anfragen von Data Mission Sync erreicht. Diese Tabelle startet, sobald wieder Kapazität frei ist.',
      Scheduled: 'Geplant',
      ScheduledTooltip:
        'Ausführung wartet in der Warteschlange, möglicherweise weil eine vorherige Synchronisierung auf der Quelltabelle noch läuft.',
      Skipped: 'Übersprungen',
      SkippedTooltip:
        'Synchronisierung wurde übersprungen und nicht ausgeführt. Klicken Sie auf die Zeile, um den Grund zu sehen.',
      Cancelling: 'Wird abgebrochen',
      CancellingTooltip: 'Eine Abbruchanforderung wurde gesendet. Die Synchronisierung wird am nächsten Prüfpunkt gestoppt.',
      Cancelled: 'Abgebrochen',
      CancelledTooltip:
        'Synchronisierung wurde manuell abgebrochen oder gestoppt, bevor sie abgeschlossen werden konnte.',
      Unknown: 'Unbekannt',
      UnknownTooltip:
        'Der Synchronisierungsstatus ist unbekannt oder konnte nicht bestimmt werden.',
    },
    skipReasons: {
      NoChangesDetected: 'Seit der letzten Synchronisierung wurden keine Änderungen erkannt',
      InsufficientEntitlements: 'Unzureichende Berechtigungen für diese Synchronisierung',
      ObsoleteCheckpoint: 'Der Checkpoint ist veraltet und eine Zurücksetzung ist erforderlich',
      InitialSyncAlreadyCompleted:
        'Die Initialsynchronisierung wurde bereits für diese Tabelle abgeschlossen',
      EntityNotAvailable:
        'Diese Entität ist in den Metadaten vorhanden, aber in dieser Umgebung nicht abfragbar',
    },
    syncMode: {
      Incremental: 'Inkrementell',
      Full: 'Vollständig',
      ResetAndFull: 'Zurücksetzen & Vollständig',
    },
    triggerSource: {
      Manual: 'Manuell',
      Scheduled: 'Geplant',
    },
    errorDialog: {
      title: 'Ausführungsfehlerdetails',
      runId: 'Ausführungs-ID',
      sourceTable: 'Quelltabelle',
      errorMessage: 'Fehlermeldung',
      errorDetail: 'Details',
      externalErrorCode: 'Externer Fehlercode',
      externalErrorMessage: 'Externe Fehlermeldung',
      close: 'Schließen',
      unknown: 'Unbekannt',
    },
    skipReasonDialog: {
      title: 'Grund für Überspringen der Ausführung',
      runId: 'Ausführungs-ID',
      sourceTable: 'Quelltabelle',
      reason: 'Grund',
      close: 'Schließen',
      unknown: 'Unbekannt',
    },
  },
  sidebar: {
    navigation: 'Navigation',
    dashboard: 'Dashboard',
    profiles: 'Profile',
    allRuns: 'Alle Ausführungen',
    organizationMembers: 'Organisationsmitglieder',
    agents: 'Agenten',
    billing: 'Abrechnung',
    settings: 'Einstellungen',
    help: 'Hilfe',
    support: 'Support',
    administration: 'Verwaltung',
    sync: 'Sync',
    organizationSwitcher: {
      noOrganizations: 'Keine Organisationen',
      organization: 'Organisation',
      organizationSingular: 'Organisation',
      organizationPlural: 'Organisationen',
      newOrganization: 'Neue Organisation',
      pendingInvitations: 'Ausstehende Einladungen',
      acceptInvitation: 'Einladung annehmen',
    },
    userMenu: {
      settings: 'Einstellungen',
      signOut: 'Abmelden',
    },
  },
  dashboard: {
    title: 'Dashboard',
    description: 'Willkommen bei DataMission',
    profileActivity: 'Profilaktivität (letzte 24 Stunden)',
    createNewProfile: 'Neues Profil erstellen',
    gettingStarted: {
      title: 'Erste Schritte',
      description: 'Erstellen Sie Ihr erstes Profil, um mit der Datensynchronisierung zu beginnen',
      createButton: 'Ihr erstes Profil erstellen',
    },
    alerts: {
      title: 'Warnungen',
      loading: 'Wird geladen...',
      incompleteProfile: 'Unvollständige Profilkonfiguration',
      profileMissing: 'Profil',
      isMissing: 'fehlt:',
      sourceConfiguration: 'Quellkonfiguration',
      targetConfiguration: 'Zielkonfiguration',
      completeSetup: 'Setup abschließen',
    },
    entitlements: {
      title: 'Organisationsübersicht',
      loading: 'Wird geladen...',
      profiles: 'Profile',
      activeAvailable: 'Aktiv / Verfügbar',
      freeTrial: 'Kostenlose Testversion',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      expires: 'Läuft ab',
      notAvailable: 'N/V',
      noActiveSubscription: 'Kein aktives Abonnement oder kostenlose Testversion',
      contactSupport: 'Bitte kontaktieren Sie den Support, um Ihr Abonnement zu aktivieren',
    },
    runSummary: {
      last24Hours: 'Letzte 24 Stunden',
      table: 'Tabelle',
      tables: 'Tabellen',
      noTablesConfigured: 'Keine Tabellen konfiguriert',
      sourceTables: 'Quelltabellen:',
      lastSync: 'Letzte Sync:',
      nextSync: 'Nächste Sync:',
      noRecentSyncs: 'Keine aktuellen Synchronisierungen',
      justNow: 'Gerade eben',
      minuteAgo: 'Minute',
      minutesAgo: 'Minuten',
      hourAgo: 'Stunde',
      hoursAgo: 'Stunden',
      dayAgo: 'Tag',
      daysAgo: 'Tage',
      totalRuns: 'Gesamtanzahl Ausführungen',
      successful: 'Erfolgreich',
      failed: 'Fehlgeschlagen',
      inProgress: 'In Bearbeitung',
      skipped: 'Übersprungen',
      successRate: 'Erfolgsquote',
    },
  },
  profiles: {
    title: 'Profile',
    description: 'Verwalten Sie Ihre Datensynchronisierungsprofile',
    createProfile: 'Profil erstellen',
    limitReached: 'Sie haben die maximale Anzahl von Profilen erreicht',
    noPermission: 'Sie haben keine Berechtigung, Profile in dieser Organisation zu erstellen',
    noProfiles: 'Keine Profile gefunden. Erstellen Sie Ihr erstes Profil, um loszulegen.',
    table: {
      name: 'Name',
      region: 'Region',
      lastSync: 'Letzte Sync',
      nextSync: 'Nächste Sync',
      tables: 'Tabellen',
      status: 'Status',
      quietTime: 'Ruhezeit',
      edit: 'Bearbeiten',
      burstActive: 'Schub aktiv',
    },
    status: {
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
    },
    sync: {
      noRecentSyncs: 'Keine aktuellen Synchronisierungen',
      justNow: 'Gerade eben',
      minutesAgo: 'Min.',
      hoursAgo: 'Std.',
      daysAgo: 'T.',
      notScheduledDisabled: 'Nicht geplant (Profil deaktiviert)',
    },
    tables: {
      noTables: 'Keine Tabellen konfiguriert',
      sourceTables: 'Quelltabellen:',
    },
    quietTime: {
      none: 'Keine',
      schedule: 'Zeitplan',
      schedules: 'Zeitpläne',
    },
    sourceTables: {
      title: 'Quelltabellen',
      description: 'Tabellen, die für die Synchronisierung aus dieser Quelle konfiguriert sind',
      logicalName: 'Logischer Name',
      status: 'Status',
      initialSyncCompleted: 'Erste Synchronisierung abgeschlossen',
      actions: 'Aktionen',
      yes: 'Ja',
      no: 'Nein',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
      enabledLabel: 'Aktiviert',
      autoDisabled: 'Automatisch deaktiviert',
      autoDisabledTitle: 'Automatisch deaktivierte Tabellen',
      autoDisabledDescription:
        'Eine oder mehrere Tabellen wurden aufgrund anhaltender Fehler automatisch deaktiviert. Bitte überprüfen Sie den Ausführungsverlauf im folgenden Abschnitt, um die zugrunde liegenden Probleme zu identifizieren und zu beheben, bevor Sie sie erneut aktivieren.',
      autoDisabledTooltip: 'Die Tabelle wurde aufgrund anhaltender Fehler automatisch deaktiviert',
      notSupported: 'Nicht unterstützt',
      notSupportedTitle: 'Nicht unterstützte Tabellen',
      notSupportedDescription:
        'Eine oder mehrere Tabellen werden derzeit nicht vom Synchronisierungsmodul unterstützt. Bitte wenden Sie sich an den Support.',
      notSupportedTooltip: 'Diese Entität wird vom Synchronisierungsmodul nicht unterstützt',
      changeTrackingRequired: 'Change Tracking erforderlich',
      changeTrackingRequiredTitle: 'Change Tracking erforderlich',
      changeTrackingRequiredDescription:
        'Eine oder mehrere Tabellen wurden automatisch deaktiviert, weil die Quelle ihre Änderungen erst liefern kann, wenn Change Tracking aktiviert ist. Bei einer Beziehungstabelle (n:m) muss Change Tracking für beide verknüpften Tabellen aktiviert sein. Aktivieren Sie es im Quellsystem und aktivieren Sie die Tabelle anschließend wieder.',
      changeTrackingRequiredTooltip: 'Aktivieren Sie Change Tracking in der Quelle (bei einer Beziehungstabelle für beide verknüpften Tabellen) und aktivieren Sie diese Tabelle anschließend wieder',
      initialSync: 'Erstsynchronisierung',
      incrementalSync: 'Inkrementelle Synchronisierung',
      inventorySync: 'Inventar synchronisieren',
      syncMode: 'Synchronisierungsmodus',
      syncModeIncremental: 'Inkrementell',
      syncModeIncrementalTooltip:
        'Die Dataverse-Änderungsnachverfolgung liefert nur geänderte Zeilen seit der letzten Synchronisierung.',
      syncModeIncrementalOnTooltip:
        'Nur Zeilen mit einem neueren {field} werden bei jeder Synchronisierung extrahiert.',
      viaFieldLabel: 'via {field}',
      syncModeFull: 'Vollständig',
      syncModeFullTooltip:
        'Es ist kein Wasserzeichenfeld verfügbar, daher extrahiert jede Synchronisierung die gesamte Tabelle erneut.',
      deletions: 'Löscherkennung',
      deletionsViaField: 'Spalte',
      deletionsViaFieldTooltip:
        "Gelöschte Zeilen werden mithilfe der Spalte '{field}' bei jeder Synchronisierung erkannt.",
      deletionsViaInventory: 'Inventar',
      deletionsViaInventoryNextDate: 'am {date}',
      deletionsViaInventoryPendingInitialSync: 'warte auf Erstsynchronisierung',
      deletionsViaInventoryTooltip:
        'Für diese Entität existiert keine Löschspalte, daher gleicht eine periodische Inventarsynchronisierung Löschungen durch Vergleich von Primärschlüsseln ab.',
      deletionsPending: 'Erkennung ausstehend',
      deletionsPendingTooltip:
        'Die Löschstrategie wird nach der ersten Synchronisierung bestimmt.',
      deletionsViaChangeTracking: 'Änderungsnachverfolgung',
      deletionsViaChangeTrackingTooltip:
        'Die Dataverse-Änderungsnachverfolgung sendet Löschereignisse nativ.',
      delete: 'Löschen',
      noTablesConfigured: 'Noch keine Quelltabellen konfiguriert.',
      noSearchResults: 'Keine Tabellen entsprechen Ihrer Suche.',
      resetAndResync: 'Zurücksetzen und neu synchronisieren',
      viewTargetSchema: 'Zielschema anzeigen',
      setParent: 'Übergeordnete Tabelle festlegen',
      childOf: 'Untergeordnet von {name}',
      parentDialogTitle: 'Übergeordnete Tabelle festlegen',
      parentDialogDescription:
        'Ordnen Sie diese Tabelle einer anderen unter, sodass sie erst synchronisiert wird, wenn die übergeordnete Tabelle abgeschlossen ist. Wählen Sie „Keine“, um sie unabhängig auszuführen.',
      parentLabel: 'Übergeordnete Tabelle',
      parentNone: 'Keine (läuft unabhängig)',
      parentUpdateSuccess: 'Übergeordnete Tabelle aktualisiert',
      deleteTitle: 'Quelltabelle löschen',
      deleteDescription: 'Das Löschen einer Quelltabelle stoppt zukünftige Synchronisierungen.',
      deleteWarning: 'Dies löscht die Quelltabelle und stoppt alle zukünftigen Synchronisierungen.',
      confirmationLabel: 'Tabellenname',
      successDeleted: 'Quelltabelle erfolgreich gelöscht',
      successReset: 'Löschen und Zurücksetzen erfolgreich initiiert',
      syncTriggeredSuccessfully: 'Synchronisierung erfolgreich ausgelöst',
      tableEnabledSuccessfully: 'Quelltabelle erfolgreich aktiviert',
      tableDisabledSuccessfully: 'Quelltabelle erfolgreich deaktiviert',
      tableDisabledSyncTooltip: 'Aktivieren Sie die Tabelle, um eine Synchronisierung zu starten',
      initialSyncInProgressTooltip: 'Die Erstsynchronisierung dieser Tabelle ist bereits geplant oder läuft',
    },
    targetSchemaDialog: {
      title: 'Zielschema',
      availableAfterFirstSync: 'Das Zielschema ist verfügbar, sobald die erste Synchronisierung abgeschlossen ist.',
      loadError: 'Das Zielschema konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
      tooLargeError: 'Das Schema dieser Tabelle ist zu groß für die Anzeige.',
      columnName: 'Spalte',
      sqlType: 'SQL Type',
      nullable: 'Nullwerte zulässig',
      primaryKey: 'Primärschlüssel',
      primaryKeyBadge: 'PK',
      close: 'Schließen',
    },
    sourceCard: {
      title: 'Quelle',
      description: 'Datenquelle für dieses Profil',
      testing: 'Wird getestet...',
      testConnection: 'Verbindung testen',
      delete: 'Löschen',
      noSourceAlert:
        'Eine Quelle muss zu diesem Profil hinzugefügt werden, um Daten zu synchronisieren. Verwenden Sie "Setup fortsetzen", um eine Dataverse-Quelle zu konfigurieren.',
      type: 'Typ',
      unknown: 'Unbekannt',
      baseUrl: 'Basis-URL',
      copyBaseUrl: 'Basis-URL kopieren',
      notAvailable: 'N/V',
      created: 'Erstellt',
      connectionStatus: 'Verbindungsstatus',
      success: 'Erfolg',
      lastTest: 'Letzter Test',
      neverTested: 'Nie getestet',
      connectionSuccessful: 'Verbindung erfolgreich',
      testSuccessful: 'Verbindungstest erfolgreich',
      testFailed: 'Verbindungstest fehlgeschlagen',
      copiedToClipboard: 'In Zwischenablage kopiert',
      failedToCopy: 'Kopieren fehlgeschlagen',
      restApiUsage: 'REST API-Nutzung',
      restApiUsageLastChecked: 'Zuletzt geprüft',
      restApiUsageNotAvailable: 'Nicht verfügbar',
      bulkApi: 'Bulk-API',
      bulkApiAvailable: 'Verfügbar',
      bulkApiUnavailable: 'Nicht verfügbar',
    },
    targetCard: {
      title: 'Ziel',
      description: 'Datenziel für dieses Profil',
      testing: 'Wird getestet...',
      testConnection: 'Verbindung testen',
      delete: 'Löschen',
      noTargetAlert:
        'Ein Ziel muss zu diesem Profil hinzugefügt werden, um Daten zu synchronisieren. Verwenden Sie "Setup fortsetzen", um ein Azure SQL-Ziel zu konfigurieren.',
      type: 'Typ',
      unknown: 'Unbekannt',
      server: 'Server',
      copyServer: 'Server kopieren',
      database: 'Datenbank',
      copyDatabase: 'Datenbank kopieren',
      schema: 'Schema',
      copySchema: 'Schema kopieren',
      tablePrefix: 'Tabellenpräfix',
      noTablePrefix: 'Keins',
      notAvailable: 'N/V',
      created: 'Erstellt',
      connectionStatus: 'Verbindungsstatus',
      success: 'Erfolg',
      lastConnectionTest: 'Letzter Verbindungstest',
      neverTested: 'Nie getestet',
      nextSync: 'Nächste Synchronisierung',
      connectionSuccessful: 'Verbindung erfolgreich',
      testSuccessful: 'Verbindungstest erfolgreich',
      testFailed: 'Verbindungstest fehlgeschlagen',
      copiedToClipboard: 'In Zwischenablage kopiert',
      failedToCopy: 'Kopieren fehlgeschlagen',
    },
    editDialog: {
      buttonText: 'Profil bearbeiten',
      title: 'Profil bearbeiten',
      description: 'Profilinformationen aktualisieren',
      name: 'Name',
      namePlaceholder: 'Mein Profil',
      region: 'Region',
      regionPlaceholder: 'eastus',
      cancel: 'Abbrechen',
      saving: 'Wird gespeichert...',
      save: 'Änderungen speichern',
      updateSuccess: 'Profil erfolgreich aktualisiert',
      dataverseLengthsTitle: 'Dataverse-Spaltenlängen',
      dataverseLengthsDescription:
        'Maximale Längen für Dataverse-Label- und Mehrfachauswahlspalten. Änderungen werden beim nächsten vollständigen Zurücksetzen und erneuten Synchronisieren jeder Tabelle wirksam.',
      lookupLabelLength: 'Lookup-Label',
      choiceLabelLength: 'Auswahl-Label',
      multiSelectLength: 'Mehrfachauswahl',
      lengthReduceWarning:
        'Das Verringern einer Länge kann bestehende Werte beim nächsten Zurücksetzen abschneiden. Wiederherstellbar durch Erhöhen und erneutes Synchronisieren.',
    },
    syncSettings: {
      buttonText: 'Sync-Einstellungen',
      title: 'Sync-Einstellungen',
      description: 'Konfigurieren Sie das Synchronisierungsverhalten für dieses Profil.',
      deleteModeLabel: 'Löschmodus',
      warningTitle: 'Warnung: Dies kann zu Datenverlust führen',
      warningDescription:
        'Das Ändern des Löschmodus nach der ersten Synchronisierung kann zu Dateninkonsistenzen oder -verlusten führen. Zuvor weich gelöschte Datensätze können dauerhaft entfernt werden, oder hart gelöschte Datensätze werden möglicherweise nicht korrekt verfolgt.',
      acknowledgeChange: 'Ich verstehe, dass dies zu Datenverlust führen kann und möchte fortfahren',
      cancel: 'Abbrechen',
      save: 'Speichern',
      saving: 'Wird gespeichert...',
      updateSuccess: 'Sync-Einstellungen erfolgreich aktualisiert',
    },
  },
  syncButton: {
    sync: 'Synchronisieren',
    syncing: 'Synchronisierung läuft...',
    incrementalSync: 'Inkrementelle Synchronisierung',
    resetAndFullSync: 'Zurücksetzen + Vollständige Synchronisierung',
  },
  profileDetail: {
    outboundIp: 'Ausgehende IP',
    status: {
      active: 'Aktiv',
      paused: 'Pausiert',
    },
    actions: {
      copyProfileId: 'Profil-ID kopieren',
      help: 'Hilfe',
      updating: 'Wird aktualisiert...',
      disable: 'Deaktivieren',
      enable: 'Aktivieren',
      enabled: 'Aktiviert',
      syncing: 'Wird synchronisiert...',
      sync: 'Synchronisieren',
      resetFullSync: 'Zurücksetzen + Vollständige Synchronisierung',
      triggerInitialSync: 'Erste Synchronisierung auslösen',
      resumeSetup: 'Setup fortsetzen',
      editProfile: 'Profil bearbeiten',
      deleteProfile: 'Profil löschen',
      actions: 'Aktionen',
      syncDisabledTooltip: 'Aktivieren Sie das Profil, um eine Synchronisierung zu starten',
    },
    quietTime: {
      title: 'Ruhezeit-Perioden',
      description: 'Synchronisierungen werden während dieser Zeitfenster übersprungen',
      addQuietTimeBlock: 'Ruhezeit-Block hinzufügen',
      loadingSchedules: 'Zeitpläne werden geladen...',
      noSchedules: 'Keine Ruhezeit-Zeitpläne konfiguriert',
      recurrence: 'Wiederholung',
      startTime: 'Startzeit',
      endTime: 'Endzeit',
      daily: 'Täglich',
      noDaysSelected: 'Keine Tage ausgewählt',
    },
    createScheduleDialog: {
      title: 'Neuen Ruhezeit-Block hinzufügen',
      description:
        'Alle Zeiten sind in UTC. Synchronisierungen werden während dieser Zeitfenster übersprungen.',
      type: 'Typ',
      everyDay: 'Jeden Tag',
      specificDays: 'Bestimmte Tage',
      selectDays: 'Tage auswählen',
      startTime: 'Startzeit (UTC)',
      endTime: 'Endzeit (UTC)',
      hourPlaceholder: 'HH',
      minutePlaceholder: 'MM',
      durationError: 'Ruhezeit darf 8 Stunden nicht überschreiten.',
      cancel: 'Abbrechen',
      creating: 'Wird erstellt...',
      create: 'Zeitplan erstellen',
      createSuccess: 'Zeitplan erfolgreich erstellt',
      createError: 'Zeitplan konnte nicht erstellt werden',
    },
    burst: {
      menuItem: 'Sync-Schub',
      title: 'Sync-Schub',
      description:
        'Führt dieses Profil vorübergehend mit beschleunigter Synchronisierungsfrequenz aus. Ruhezeiten werden weiterhin berücksichtigt.',
      windowLabel: 'Schub-Fenster (Stunden)',
      windowHelp:
        'Läuft mit einer beschleunigten 5-Minuten-Synchronisierung bis zu {max} Stunden und kehrt dann zum normalen Zeitplan zurück.',
      activeUntil: 'Schub aktiv bis {time}.',
      activeBadge: 'Schub aktiv',
      overlapWarning:
        'Dieses Schub-Fenster überschneidet sich mit einer Ruhezeit; Synchronisierungen werden während Ruhezeiten weiterhin übersprungen.',
      activate: 'Schub aktivieren',
      stop: 'Schub stoppen',
      cancel: 'Abbrechen',
      activateSuccess: 'Schub aktiviert',
      activateError: 'Schub konnte nicht aktiviert werden',
      stopSuccess: 'Schub gestoppt',
      stopError: 'Schub konnte nicht gestoppt werden',
    },
    daysOfWeek: {
      sunday: 'Sonntag',
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
    },
    runHistory: {
      title: 'Ausführungsverlauf',
      description: 'Synchronisierungen für dieses Profil anzeigen',
      recentRuns: 'Aktuelle Ausführungen',
    },
    errors: {
      failedToLoad: 'Profil konnte nicht geladen werden',
      copiedToClipboard: 'In Zwischenablage kopiert',
      failedToCopy: 'Kopieren fehlgeschlagen',
      profileEnabled: 'Profil erfolgreich aktiviert',
      profileDisabled: 'Profil erfolgreich deaktiviert',
      syncTriggered: 'Synchronisierung erfolgreich ausgelöst',
      failedToLoadRuns: 'Ausführungen konnten nicht geladen werden',
    },
    helpContent: {
      profileHelp: 'Profil-Hilfe',
      profileHelpDescription:
        'Erfahren Sie mehr über die Verwaltung von Profilen, Synchronisierungen und Ausführungsverlauf',
      setupChecklistTitle: 'Profil-Setup-Checkliste',
      setupChecklistDescription: 'Verfolgen Sie den Fortschritt Ihrer Profilkonfiguration',
      checklistItems: {
        configureSource: 'Quelle konfigurieren',
        configureTarget: 'Ziel konfigurieren',
        selectTables: 'Zu synchronisierende Tabellen auswählen',
        configureQuietTime: 'Ruhezeit konfigurieren',
        configureDeleteMode: 'Löschmodus konfigurieren',
        runInitialSync: 'Erste Synchronisierung ausführen',
      },
      allStepsCompleted:
        '✓ Alle Setup-Schritte abgeschlossen! Ihr Profil ist bereit für die Synchronisierung.',
      profileStatus: {
        title: 'Profilstatus',
        active: 'Aktiv:',
        activeDescription: 'Profil ist aktiviert und kann geplante Synchronisierungen ausführen',
        paused: 'Pausiert:',
        pausedDescription: 'Profil ist deaktiviert und Synchronisierungen werden nicht ausgeführt',
      },
      syncActions: {
        title: 'Synchronisierungsaktionen',
        sync: 'Synchronisieren:',
        syncDescription:
          'Führt eine inkrementelle Synchronisierung durch, bei der nur neue oder geänderte Daten verarbeitet werden',
        resetFullSync: 'Zurücksetzen + Vollständige Synchronisierung:',
        resetFullSyncDescription:
          'Löscht alle vorhandenen Daten und führt eine vollständige Synchronisierung von der Quelle durch. Dies ist eine destruktive Operation.',
        triggerInitialSync: 'Erste Synchronisierung auslösen:',
        triggerInitialSyncDescription:
          'Führt die erste Synchronisierung nach der Einrichtung von Quelle und Ziel aus',
      },
      sourceAndTarget: {
        title: 'Quelle und Ziel',
        source: 'Quelle:',
        sourceDescription: 'Die Datenquelle, aus der Ihre Daten stammen',
        target: 'Ziel:',
        targetDescription: 'Das Ziel, an dem synchronisierte Daten gespeichert werden',
        configurationNote:
          'Sowohl Quelle als auch Ziel müssen konfiguriert sein, bevor Sie Synchronisierungen auslösen können',
      },
      quietTimePeriods: {
        title: 'Ruhezeit-Perioden',
        description:
          'Konfigurieren Sie Zeitfenster, in denen Synchronisierungen automatisch übersprungen werden. Dies ist nützlich, um Synchronisierungen während Wartungsfenstern oder Spitzenzeiten zu vermeiden.',
      },
      runHistory: {
        title: 'Ausführungsverlauf',
        viewAllRuns:
          'Alle Synchronisierungsausführungen für dieses Profil anzeigen, einschließlich Status, Dauer und Ergebnisse',
        filterRuns:
          'Ausführungen nach Status (Abgeschlossen, Fehlgeschlagen usw.) oder nach Quelltabelle filtern',
        clickFailedRuns:
          'Klicken Sie auf fehlgeschlagene Ausführungen, um detaillierte Fehlerinformationen anzuzeigen',
        usePagination:
          'Verwenden Sie die Paginierungssteuerung, um durch historische Ausführungen zu navigieren',
      },
      runStates: {
        title: 'Ausführungszustände',
        completed: 'Abgeschlossen:',
        completedDescription: 'Synchronisierung erfolgreich abgeschlossen',
        failed: 'Fehlgeschlagen:',
        failedDescription: 'Synchronisierung ist auf einen Fehler gestoßen',
        extractingLoading: 'Extrahieren/Laden:',
        extractingLoadingDescription: 'Synchronisierung läuft',
        scheduled: 'Geplant:',
        scheduledDescription: 'Synchronisierung ist zur Ausführung in die Warteschlange gestellt',
        skipped: 'Übersprungen:',
        skippedDescription:
          'Synchronisierung wurde übersprungen (z. B. aufgrund einer Ruhezeit-Periode)',
        cancelled: 'Abgebrochen:',
        cancelledDescription: 'Synchronisierung wurde abgebrochen',
      },
    },
  },
  wizard: {
    advancedSettings: {
      title: 'Erweiterte Einstellungen',
      description: 'Optional. Die meisten Kunden können diese unverändert lassen.',
    },
    steps: {
      profile: 'Profil',
      source: 'Quelle',
      target: 'Ziel',
      tables: 'Tabellen',
      quietTime: 'Ruhezeit',
      deleteMode: 'Löschmodus',
      initialSync: 'Erste Synchronisierung',
    },
    availableTableDisabledReasons: {
      ChangeTrackingDisabled: 'Aktivieren Sie die Änderungsverfolgung, um diese Entität zu verwenden.',
      NotSupported: 'Diese Entität wird derzeit nicht unterstützt. Bitte wenden Sie sich an den Support.',
      RelatedChangeTrackingDisabled: 'Aktivieren Sie Change Tracking für beide verknüpften Tabellen, um diese Beziehungstabelle zu verwenden.',
      VirtualTable: 'Dies ist eine virtuelle Tabelle: Ihre Daten werden nicht in Dataverse gespeichert, daher kann sie nicht synchronisiert werden.',
    },
    common: {
      back: 'Zurück',
      next: 'Weiter',
      cancel: 'Abbrechen',
      create: 'Erstellen',
      save: 'Speichern',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      add: 'Hinzufügen',
      remove: 'Entfernen',
      update: 'Aktualisieren',
      submit: 'Absenden',
      close: 'Schließen',
      copy: 'Kopieren',
      copied: 'Kopiert',
      copyToClipboard: 'In Zwischenablage kopiert',
      failedToCopy: 'Kopieren fehlgeschlagen',
    },
    profile: {
      title: 'Profil erstellen',
      titleEdit: 'Profildetails',
      description: 'Ein neues Datensynchronisierungsprofil einrichten',
      descriptionEdit: 'Ihre Profilkonfiguration anzeigen',
      cardTitle: 'Profildetails',
      cardDescription: 'Konfigurieren Sie die Grundeinstellungen für Ihr Profil',
      profileName: 'Profilname',
      profileNamePlaceholder: 'Mein Datensynchronisierungsprofil',
      region: 'Region',
      regionPlaceholder: 'Region auswählen',
      creating: 'Wird erstellt...',
      nextConfigureSource: 'Weiter: Quelle konfigurieren',
      profileCreatedSuccessfully: 'Profil erfolgreich erstellt',
      pleaseEnterProfileName: 'Bitte geben Sie einen Profilnamen ein',
      advancedLengthsInvalid: 'Die Spaltenlängen von Dataverse müssen zwischen 50 und 4000 liegen.',
    },
    source: {
      title: 'Quelle konfigurieren',
      description: 'Verbinden Sie sich mit Ihrer Datenquelle',
      cardTitle: 'Verbindungsdetails',
      cardDescription: 'Geben Sie Ihre Anmeldedaten und Verbindungsdetails ein',
      sourceType: 'Quellentyp',
      selectSourceType: 'Quellentyp auswählen',
      dataverse: 'Dataverse',
      businessCentral: 'Business Central',
      salesforce: 'Salesforce',
      baseUrl: 'Basis-URL',
      baseUrlPlaceholder: 'https://yourorg.crm.dynamics.com',
      pageSize: 'Seitengröße',
      pageSizePlaceholder: '3000',
      pageSizeDescription: 'Datensätze pro Dataverse-API-Aufruf (1000–5000). Verringern Sie den Wert, wenn sehr breite Tabellen ein Timeout haben; erhöhen Sie ihn, um API-Aufrufe zu reduzieren. Standard 3000.',
      pageSizeRange: 'Die Seitengröße muss zwischen 1000 und 5000 liegen',
      tenantId: 'Mandanten-ID',
      tenantIdPlaceholder: 'Azure AD-Mandanten-ID eingeben',
      bcEnvironment: 'Umgebung',
      bcEnvironmentPlaceholder: 'z.B. production',
      instanceUrl: 'Instanz-URL',
      instanceUrlPlaceholder: 'https://mycompany.my.salesforce.com',
      isSandbox: 'Sandbox-Organisation',
      isSandboxDescription: 'Aktivieren, wenn es sich um eine Salesforce-Sandbox-Umgebung handelt',
      clientId: 'Client-ID',
      clientIdPlaceholder: 'Client-ID eingeben',
      clientSecret: 'Client-Geheimnis',
      clientSecretPlaceholder: 'Client-Geheimnis eingeben',
      consumerKey: 'Consumer Key',
      consumerKeyPlaceholder: 'Consumer Key eingeben',
      secret: 'Secret',
      secretPlaceholder: 'Secret eingeben',
      testConnection: 'Verbindung testen',
      testConnectionAndLoadCompanies: 'Verbindung testen & Unternehmen laden',
      testing: 'Verbindung wird getestet...',
      connectionSuccessful: 'Verbindung erfolgreich',
      company: 'Unternehmen',
      companyPlaceholder: 'Unternehmen auswählen',
      noCompaniesFound: 'Keine Unternehmen gefunden',
      allFieldsRequired: 'Alle Felder sind erforderlich, um die Verbindung zu testen',
      testBeforeProceeding: 'Bitte testen Sie die Verbindung erfolgreich, bevor Sie fortfahren',
      selectCompanyBeforeProceeding: 'Bitte wählen Sie ein Unternehmen aus, bevor Sie fortfahren',
      back: 'Zurück',
      next: 'Weiter: Ziel konfigurieren',
      creating: 'Wird erstellt...',
    },
    target: {
      title: 'Ziel konfigurieren',
      description: 'Verbinden Sie sich mit Ihrer Azure SQL-Datenbank',
      cardTitle: 'Azure SQL-Verbindung',
      cardDescription: 'Geben Sie Ihre Azure SQL-Datenbank-Anmeldedaten und Details ein',
      warning:
        'Warnung: Nach der ersten Synchronisierung kann das Ziel nicht mehr geändert werden.',
      firewallTitle: 'Firewall-Konfiguration erforderlich',
      firewallDescription:
        'Um Data Mission die Verbindung zu Ihrem Azure SQL-Server zu ermöglichen, wählen Sie eine dieser Optionen:',
      firewallOptionAzure:
        'Aktivieren Sie "Azure-Diensten und -Ressourcen Zugriff auf diesen Server erlauben" in den Netzwerkeinstellungen Ihres Azure SQL-Servers.',
      firewallOptionAzureLabel: 'Option 2:',
      firewallOptionIpRecommended: 'Option 1 (Empfohlen):',
      firewallOptionIpDescription:
        'Fügen Sie die folgende statische IP-Adresse zu den Firewall-Regeln Ihres Azure SQL-Servers hinzu:',
      firewallIpUnavailable:
        'Statische IP für diese Region nicht verfügbar. Verwenden Sie stattdessen Option 1.',
      firewallSummary:
        'Möglicherweise ist eine zusätzliche Netzwerkkonfiguration erforderlich, damit unsere Dienste auf Ihren Azure SQL-Server zugreifen können.',
      firewallLearnMore: 'Mehr erfahren',
      firewallClose: 'Schließen',
      authType: 'Authentifizierungstyp',
      authTypeServicePrincipal: 'Dienstprinzipal (AAD)',
      authTypeServicePrincipalDescription:
        'Mit Azure AD-Dienstprinzipal-Anmeldedaten authentifizieren',
      authTypeSqlCredential: 'SQL-Anmeldedaten',
      authTypeSqlCredentialDescription:
        'Mit einem SQL-Benutzernamen und Passwort authentifizieren',
      useSourceClientId: 'Client-ID der Quelle verwenden',
      useSourceClientIdDescription:
        'Kopieren Sie die Client-ID aus der Quelle. Sie müssen weiterhin die Mandanten-ID und das Client-Geheimnis angeben.',
      usingClientIdFromSource: 'Client-ID aus der Quelle wird verwendet',
      tenantId: 'Mandanten-ID',
      tenantIdPlaceholder: 'Mandanten-ID eingeben',
      clientId: 'Client-ID',
      clientIdPlaceholder: 'Client-ID eingeben',
      clientSecret: 'Client-Geheimnis',
      clientSecretPlaceholder: 'Client-Geheimnis eingeben',
      username: 'Benutzername',
      usernamePlaceholder: 'SQL-Benutzername eingeben',
      usernameDescription: 'Der SQL Server-Anmeldebenutzername',
      password: 'Passwort',
      passwordPlaceholder: 'SQL-Passwort eingeben',
      passwordDescription: 'Das SQL Server-Anmeldepasswort',
      encryptConnection: 'Verbindung verschlüsseln',
      encryptConnectionDescription: 'Deaktivieren, wenn eine Verbindung zu einem lokalen SQL Server ohne konfiguriertes TLS hergestellt wird',
      server: 'Server',
      serverPlaceholder: 'yourserver.database.windows.net',
      database: 'Datenbank',
      databasePlaceholder: 'Datenbankname eingeben',
      schema: 'Schemaname',
      schemaPlaceholder: 'dbo',
      tablePrefix: 'Tabellenpräfix (optional)',
      tablePrefixPlaceholder: 'z.B. dms_',
      tablePrefixDescription: 'Wird auf jede Tabelle angewendet, die dieses Profil erstellt (z.B. dms_account). Fügen Sie Ihr eigenes Trennzeichen hinzu. Nur Buchstaben, Ziffern und Unterstriche.',
      tablePrefixInvalid: 'Das Tabellenpräfix darf nur Buchstaben, Ziffern und Unterstriche enthalten.',
      agent: 'Agent',
      agentPlaceholder: 'Agent auswählen',
      agentDescription: 'Optional einen selbst gehosteten Agenten zuweisen, um Synchronisierungsvorgänge für dieses Ziel auszuführen',
      agentNone: 'Keiner (Cloud-gehostet)',
      testConnection: 'Verbindung testen',
      testing: 'Verbindung wird getestet...',
      connectionSuccessful: 'Verbindung erfolgreich',
      allFieldsRequired: 'Alle Felder sind erforderlich, um die Verbindung zu testen',
      testBeforeProceeding: 'Bitte testen Sie die Verbindung erfolgreich, bevor Sie fortfahren',
      validationFailed: 'Validierung fehlgeschlagen. Bitte überprüfen Sie das Formular.',
      back: 'Zurück',
      next: 'Weiter: Tabellen auswählen',
      creating: 'Wird erstellt...',
    },
    tables: {
      title: 'Tabellen auswählen',
      description: 'Wählen Sie die zu synchronisierenden Tabellen aus',
      cardTitle: 'Verfügbare Tabellen',
      cardDescription:
        'Wählen Sie eine oder mehrere Tabellen aus Ihrer Dataverse-Quelle zur Synchronisierung aus',
      tablesLabel: 'Tabellen',
      selected: 'ausgewählt',
      selectAll: 'Alle auswählen',
      deselectAll: 'Alle abwählen',
      searchPlaceholder: 'Tabellen nach Namen suchen...',
      loadingTables: 'Tabellen werden geladen...',
      noTablesFound: 'Keine Tabellen gefunden, die Ihrer Suche entsprechen',
      noTablesAvailable: 'Keine Tabellen verfügbar',
      pleaseSelectAtLeastOne: 'Bitte wählen Sie mindestens eine Tabelle aus',
      sourceNotFound: 'Quelle nicht gefunden',
      addingTables: 'Tabellen werden hinzugefügt...',
      finishAddTables: 'Fertigstellen und {count} Tabelle hinzufügen',
      finishAddTablesPlural: 'Fertigstellen und {count} Tabellen hinzufügen',
      sourceTablesAddedSuccessfully: 'Quelltabellen erfolgreich hinzugefügt',
      nextConfigureQuietTime: 'Weiter: Ruhezeit konfigurieren',
      back: 'Zurück',
      timestampField: 'Zeitstempelfeld für inkrementelle Synchronisierung wählen',
      timestampFieldDescription: 'Feld für inkrementelle Synchronisierung',
      timestampFieldNone: 'Keines (vollständige Replikation)',
      incrementalSyncVia: 'Inkrementelle Synchronisierung über {field}',
      fullReplication: 'Vollständige Replikation (kein Zeitstempelfeld verfügbar)',
      noTimestampFieldNotice: 'Für diese Tabelle sind keine Zeitstempelspalten verfügbar. Jede Synchronisierung führt eine vollständige Replikation aller Datensätze durch.',
      nameTooLongForPrefix: 'Name zu lang für das Tabellenpräfix dieses Profils.',
    },
    quietTime: {
      title: 'Ruhezeit konfigurieren',
      description:
        'Richten Sie Zeitfenster ein, in denen Synchronisierungen automatisch übersprungen werden',
      cardTitle: 'Ruhezeit-Periode',
      cardDescription:
        'Konfigurieren Sie Zeitfenster, in denen Synchronisierungen übersprungen werden. Dies ist optional, wird aber empfohlen.',
      infoAlert:
        'Alle Zeiten sind in UTC. Ruhezeit-Perioden helfen, Synchronisierungen während Wartungsfenstern oder Spitzenzeiten zu vermeiden.',
      existingSchedules:
        'Sie haben {count} Ruhezeit-Zeitplan konfiguriert. Sie können unten weitere hinzufügen oder zur nächsten Schritt fortfahren.',
      existingSchedulesPlural:
        'Sie haben {count} Ruhezeit-Zeitpläne konfiguriert. Sie können unten weitere hinzufügen oder zur nächsten Schritt fortfahren.',
      type: 'Typ',
      typeDaily: 'Jeden Tag',
      typeWeekly: 'Bestimmte Tage',
      selectDays: 'Tage auswählen',
      startTime: 'Startzeit (UTC)',
      endTime: 'Endzeit (UTC)',
      hourPlaceholder: 'HH',
      minutePlaceholder: 'MM',
      durationExceeded:
        'Ruhezeit darf 8 Stunden nicht überschreiten. Aktuelle Dauer: {hours} Stunden',
      addQuietTimeBlock: 'Ruhezeit-Block hinzufügen',
      creating: 'Wird erstellt...',
      quietTimeScheduleCreatedSuccessfully: 'Ruhezeit-Zeitplan erfolgreich erstellt',
      back: 'Zurück',
      nextConfigureDeleteMode: 'Weiter: Löschmodus konfigurieren',
      sunday: 'Sonntag',
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      configuredSchedules: 'Konfigurierte Zeitpläne',
      recurrence: 'Wiederholung',
      noDaysSelected: 'Keine Tage ausgewählt',
    },
    deleteMode: {
      title: 'Löschmodus konfigurieren',
      description:
        'Wählen Sie, wie gelöschte Datensätze während der Synchronisierung behandelt werden',
      cardTitle: 'Löschmodus',
      cardDescription: 'Wählen Sie, wie Sie gelöschte Datensätze aus der Quelle behandeln möchten',
      softDelete: 'Soft Delete',
      softDeleteDescription:
        'Datensätze als gelöscht markieren (IsDeleted = true), aber in der Datenbank behalten. Ideal für Audit-Trails und historische Daten.',
      hardDelete: 'Hard Delete',
      hardDeleteDescription:
        'Datensätze physisch aus der Datenbank entfernen, wenn sie in der Quelle gelöscht werden.',
      infoMessage:
        'Diese Einstellung bestimmt, wie gelöschte Datensätze im Quellsystem in der Zieldatenbank behandelt werden. Wählen Sie sorgfältig, da dies die Datenintegrität beeinflusst.',
      recommended: 'Empfohlen',
      warningAfterInitialSync:
        'Warnung: Das Ändern des Löschmodus nach der ersten Synchronisierung kann zu Dateninkonsistenzen führen. Vorsicht walten lassen.',
      saving: 'Wird gespeichert...',
      nextRunInitialSync: 'Weiter: Erste Synchronisierung ausführen',
      successMessage: 'Löschmodus erfolgreich konfiguriert',
      back: 'Zurück',
    },
    initialSync: {
      title: 'Erste Synchronisierung ausführen',
      description:
        'Lösen Sie die erste Synchronisierung aus, um mit der Synchronisierung Ihrer Daten zu beginnen',
      cardTitle: 'Erste Synchronisierung',
      cardDescription:
        'Führen Sie Ihre erste Synchronisierung aus, um mit der Synchronisierung der Daten von Ihrer Quelle zu Ihrem Ziel zu beginnen',
      infoAlert:
        'Die erste Synchronisierung verarbeitet alle ausgewählten Tabellen und erstellt den ersten Datensatz in Ihrer Zieldatenbank. Dies kann je nach Datenmenge einige Zeit dauern.',
      triggeredSuccessfully:
        'Erste Synchronisierung erfolgreich ausgelöst! Weiterleitung zur Profilseite...',
      triggering: 'Erste Synchronisierung wird ausgelöst...',
      triggeringButton: 'Wird ausgelöst...',
      triggeredButton: 'Ausgelöst',
      triggerInitialSync: 'Erste Synchronisierung auslösen',
      initialSyncTriggeredSuccessfully: 'Erste Synchronisierung erfolgreich ausgelöst',
      back: 'Zurück',
    },
  },
  organizationSetupWizard: {
    title: 'Mission Data',
    createError: 'Organisation konnte nicht erstellt werden',
    unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten',
    regionSetupError: 'Organisationseinstellungen konnten nicht aktualisiert werden',
    setupComplete: 'Organisationseinrichtung abgeschlossen',
  },
  organizationWizard: {
    welcome: {
      title: 'Willkommen bei Mission Impact Data Mission',
      description: 'Lassen Sie uns Ihre Organisation einrichten',
      intro:
        'Um zu beginnen, müssen Sie eine Organisation erstellen. Eine Organisation hilft Ihnen dabei:',
      benefit1: 'Teammitglieder und deren Zugriff verwalten',
      benefit2: 'Ihre Datenquellen und Profile organisieren',
      benefit3: 'Mit anderen an Datenintegrationsaufgaben zusammenarbeiten',
      benefit4: 'Ihre Arbeit von anderen Organisationen trennen',
      creatorNote:
        'Als Ersteller werden Sie automatisch zum Administrator mit vollständiger Kontrolle über Ihre Organisation.',
      getStarted: 'Loslegen',
    },
    name: {
      title: 'Erstellen Sie Ihre Organisation',
      description: 'Wählen Sie einen Namen für Ihre Organisation',
      organizationName: 'Organisationsname',
      organizationNamePlaceholder: 'Organisationsname eingeben',
      organizationNameCannotBeEmpty: 'Organisationsname darf nicht leer sein',
      creating: 'Wird erstellt...',
      createOrganization: 'Organisation erstellen',
    },
    language: {
      title: 'Wählen Sie Ihre Sprache',
      description: 'Wählen Sie Ihre bevorzugte Sprache für die Anwendung',
      languageLabel: 'Sprache',
      languageDescription: 'Sie können dies später in den Einstellungen ändern',
      english: 'English',
      french: 'Français',
      german: 'Deutsch',
      spanish: 'Español',
      continue: 'Weiter',
    },
    region: {
      title: 'Standardregion festlegen',
      description: 'Wählen Sie eine standardmäßige Azure-Region für Ihre Organisation',
      defaultRegion: 'Standardregion',
      defaultRegionDescription:
        'Die standardmäßige Azure-Region für neue Profile in dieser Organisation',
      noDefaultRegion: 'Keine Standardregion',
      saving: 'Wird gespeichert...',
      complete: 'Einrichtung abschließen',
    },
    success: {
      title: 'Organisation erfolgreich erstellt',
      description: 'Ihre Organisation ist einsatzbereit',
      message: 'Ihre Organisation wurde erstellt und Sie wurden als Administrator zugewiesen.',
      redirecting: 'Weiterleitung zum Dashboard...',
    },
  },
  userOnboardingWizard: {
    title: 'Willkommen bei Data Mission',
    steps: {
      welcome: 'Willkommen',
      language: 'Sprache',
      theme: 'Thema',
      organization: 'Organisation',
      eula: 'Vereinbarung',
      complete: 'Fertig',
    },
    welcomeStep: {
      title: 'Willkommen bei Data Mission',
      description: 'Lassen Sie uns Ihr Konto einrichten',
      intro:
        'Data Mission hilft Ihnen, Ihre Microsoft Dataverse-Daten mit Ihrer eigenen SQL Server-Datenbank zu synchronisieren und gibt Ihnen die volle Kontrolle über Ihre Daten für Berichte und Analysen.',
      feature1: 'Automatische, inkrementelle Datensynchronisation',
      feature2: 'Volle Kontrolle über Ihre synchronisierten Daten',
      feature3: 'Einfache Einrichtung mit geführter Konfiguration',
      getStarted: 'Loslegen',
    },
    languageStep: {
      title: 'Wählen Sie Ihre Sprache',
      description: 'Wählen Sie Ihre bevorzugte Sprache für die Anwendung',
      languageLabel: 'Sprache',
      continue: 'Weiter',
    },
    themeStep: {
      title: 'Wählen Sie Ihr Thema',
      description: 'Wählen Sie Ihr bevorzugtes Farbthema',
      light: 'Hell',
      lightDescription: 'Ein helles Thema für die Nutzung am Tag',
      dark: 'Dunkel',
      darkDescription: 'Ein dunkleres Thema, das angenehmer für die Augen ist',
      system: 'System',
      systemDescription: 'Automatisch an Ihre Systemeinstellungen anpassen',
      back: 'Zurück',
      continue: 'Weiter',
    },
    organizationStep: {
      title: 'Ihre Organisationen',
      description:
        'Organisationen helfen Ihnen, Ihr Team und Ihre Daten zu verwalten. Eine Organisation ist erforderlich, um Data Mission zu verwenden.',
      activeMemberships: 'Aktive Mitgliedschaften',
      pendingInvites: 'Ausstehende Einladungen',
      pendingInvitesDescription: 'Sie wurden eingeladen, folgenden Organisationen beizutreten',
      role: 'Rolle',
      expires: 'Läuft ab',
      accept: 'Annehmen',
      accepting: 'Wird angenommen...',
      decline: 'Ablehnen',
      declining: 'Wird abgelehnt...',
      createNew: 'Organisation erstellen',
      createNewDescription: 'Starten Sie mit Ihrer eigenen Organisation',
      organizationName: 'Organisationsname',
      organizationNamePlaceholder: 'Organisationsname eingeben',
      organizationNameRequired: 'Organisationsname ist erforderlich',
      creating: 'Wird erstellt...',
      create: 'Organisation erstellen',
      back: 'Zurück',
      acceptError: 'Einladung konnte nicht angenommen werden. Bitte versuchen Sie es erneut.',
      declineError: 'Einladung konnte nicht abgelehnt werden. Bitte versuchen Sie es erneut.',
      createError: 'Organisation konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    },
    agreementStep: {
      title: 'Nutzungsbedingungen',
      description: 'Bitte lesen und akzeptieren Sie die Bedingungen, um fortzufahren',
      loading: 'Wird geladen...',
      loadError: 'Die Vereinbarung konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
      accept: 'Akzeptieren',
      accepting: 'Akzeptieren...',
      back: 'Zurück',
      acceptError: 'Die Vereinbarung konnte nicht akzeptiert werden. Bitte versuchen Sie es erneut.',
      noAgreementsRequired: 'Derzeit müssen keine Vereinbarungen akzeptiert werden.',
      privacyPolicyTitle: 'Datenschutzrichtlinie',
      termsOfUseTitle: 'Nutzungsbedingungen',
      scrollToAccept: 'Zum Akzeptieren nach unten scrollen',
    },
    communicationPreferencesStep: {
      title: 'Wählen Sie Ihre Kommunikationspräferenzen',
      description: 'Wählen Sie die Arten von Mitteilungen, die Sie von uns erhalten möchten',
      productUpdates: {
        label: 'Produkt-Updates, Funktionen & Services',
        description: 'Bleiben Sie über neue Funktionen, Produkt-Updates und Service-Verbesserungen informiert.',
      },
      newsTrainingArticles: {
        label: 'Neuigkeiten, Schulungen und Artikel',
        description: 'Wir senden Ihnen E-Mails mit Neuigkeiten, Schulungs-Updates und hilfreichen Artikeln über Data Mission Sync.',
      },
      back: 'Zurück',
      continue: 'Weiter',
      saving: 'Wird gespeichert...',
      saveError: 'Kommunikationspräferenzen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    },
    completeStep: {
      title: 'Einrichtung abgeschlossen',
      description: 'Sie sind bereit, Data Mission zu verwenden',
      summary: 'Ihre Einstellungen',
      language: 'Sprache',
      theme: 'Thema',
      completing: 'Wird abgeschlossen...',
      complete: 'Loslegen',
      error: 'Einrichtung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    },
  },
  dialogs: {
    deleteProfile: {
      title: 'Profil löschen',
      description: 'Sind Sie sicher, dass Sie das Profil löschen möchten',
      confirmationLabel: 'Profilname',
      buttonText: 'Profil löschen',
      successMessage: 'Profil erfolgreich gelöscht',
      warningIntro: 'Das Löschen dieses Profils löscht auch dauerhaft:',
      warningSources: 'Alle mit diesem Profil verknüpften Quellen',
      warningTargets: 'Alle mit diesem Profil verknüpften Ziele',
      warningSourceTables: 'Alle Quelltabellen, die mit den Quellen verknüpft sind',
      warningWebhooks: 'Alle Webhook-Abonnements, die mit den Quellen verknüpft sind',
    },
    deleteSource: {
      title: 'Quelle löschen',
      description: 'Sind Sie sicher, dass Sie diese Quelle löschen möchten?',
      confirmationKey: 'QUELLE LÖSCHEN',
      confirmationLabel: 'Bestätigungstext',
      buttonText: 'Löschen',
      successMessage: 'Quelle erfolgreich gelöscht',
      warningIntro: 'Das Löschen dieser Quelle löscht auch dauerhaft:',
      warningRoutes: 'Alle Routen, die diese Quelle verwenden',
      warningSourceTables: 'Alle Quelltabellen, die mit dieser Quelle verknüpft sind',
      warningWebhooks: 'Alle Webhook-Abonnements, die mit dieser Quelle verknüpft sind',
      baseUrl: 'Basis-URL:',
    },
    deleteTarget: {
      title: 'Ziel löschen',
      description: 'Sind Sie sicher, dass Sie dieses Ziel löschen möchten?',
      buttonText: 'Ziel löschen',
      cancel: 'Abbrechen',
      deleting: 'Wird gelöscht...',
      successMessage: 'Ziel erfolgreich gelöscht',
      warning: 'Warnung: Diese Aktion kann nicht rückgängig gemacht werden.',
      warningDescription: 'Das Löschen dieses Ziels löscht auch dauerhaft:',
      warningRoutes: 'Alle Routen, die dieses Ziel verwenden',
      server: 'Server:',
      database: 'Datenbank:',
    },
    deleteSchedule: {
      title: 'Zeitplan löschen',
      description:
        'Sind Sie sicher, dass Sie diesen Ruhezeitplan löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      successMessage: 'Zeitplan erfolgreich gelöscht',
      errorMessage: 'Fehler beim Löschen des Zeitplans',
    },
    confirmDelete: {
      warning: 'WARNUNG:',
      defaultWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      typeToConfirm: 'Geben Sie Folgendes ein, um zu bestätigen:',
      enterPrefix: 'Eingeben',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      deleting: 'Wird gelöscht...',
    },
    newOrganization: {
      title: 'Neue Organisation erstellen',
      description:
        'Geben Sie einen Namen für Ihre neue Organisation ein. Sie können dies später in den Einstellungen ändern.',
      organizationName: 'Organisationsname',
      organizationNamePlaceholder: 'Meine Organisation',
      billingCountry: 'Rechnungsland',
      billingCountryDescription: 'Wählen Sie das Land für Rechnungszwecke aus. Dies kann später nicht geändert werden.',
      billingCountryPlaceholder: 'Land auswählen',
      billingCountrySearch: 'Länder suchen...',
      billingCountryNoResults: 'Kein Land gefunden.',
      cancel: 'Abbrechen',
      create: 'Erstellen',
      organizationCreatedSuccessfully: 'Organisation erfolgreich erstellt!',
    },
    setBillingCountry: {
      title: 'Rechnungsland festlegen',
      description: 'Bitte wählen Sie ein Rechnungsland für Ihre Organisation. Dies ist erforderlich, um fortzufahren.',
      billingCountry: 'Rechnungsland',
      billingCountryRequired: 'Ein Rechnungsland ist erforderlich',
      save: 'Speichern',
      saving: 'Wird gespeichert...',
      billingCountryUpdated: 'Rechnungsland erfolgreich aktualisiert!',
    },
    inviteUser: {
      title: 'Neuen Benutzer einladen',
      description:
        'Senden Sie eine Einladung an einen neuen Benutzer, um Ihrer Organisation beizutreten',
      email: 'E-Mail',
      emailPlaceholder: 'max.mustermann@beispiel.com',
      role: 'Rolle',
      rolePlaceholder: 'Rolle auswählen',
      roleReader: 'Leser',
      roleOperator: 'Betreiber',
      roleAdministrator: 'Administrator',
      roleBillingManager: 'Abrechnungsmanager',
      roleExpiration: 'Ablaufdatum der Rolle (Optional)',
      roleExpirationPlaceholder: 'Datum auswählen',
      roleExpiresOn: 'Die Rolle des Benutzers läuft ab am {date}',
      invitationExpiresNote: 'Hinweis: Die Einladung läuft automatisch 7 Tage nach dem Versand ab',
      cancel: 'Abbrechen',
      sending: 'Wird gesendet...',
      sendInvite: 'Einladung senden',
      userInvitedSuccessfully: 'Benutzer erfolgreich eingeladen!',
    },
    editUserRole: {
      title: 'Benutzerrolle bearbeiten',
      description: 'Ändern Sie die Rolle für {email}',
      roleLabel: 'Rolle',
      rolePlaceholder: 'Neue Rolle auswählen',
      membershipExpiration: 'Ablaufdatum der Mitgliedschaft (Optional)',
      membershipExpirationIndefinite: 'Unbefristet',
      membershipExpiresOn: 'Die Mitgliedschaft läuft ab am {date}',
      clearExpiration: 'Löschen',
      cancel: 'Abbrechen',
      update: 'Rolle aktualisieren',
      updating: 'Aktualisieren...',
      triggerLabel: 'Benutzerrolle bearbeiten',
      roleUpdated: 'Rolle erfolgreich aktualisiert',
    },
    removeMember: {
      title: 'Benutzer entfernen',
      description: 'Möchten Sie {email} wirklich aus dieser Organisation entfernen?',
      cancel: 'Abbrechen',
      remove: 'Benutzer entfernen',
      removing: 'Entfernen...',
      triggerLabel: 'Benutzer aus der Organisation entfernen',
      userRemoved: 'Benutzer wurde aus der Organisation entfernt',
    },
    reinviteUser: {
      title: 'Benutzer erneut einladen',
      description: 'Neue Einladung an {email} senden',
      emailLabel: 'E-Mail',
      roleLabel: 'Rolle',
      rolePlaceholder: 'Rolle auswählen',
      membershipExpiration: 'Ablaufdatum der Mitgliedschaft (Optional)',
      membershipExpirationIndefinite: 'Unbefristet',
      membershipExpiresOn: 'Die Mitgliedschaft läuft ab am {date}',
      clearExpiration: 'Löschen',
      invitationExpiresNote: 'Hinweis: Die Einladung läuft automatisch 7 Tage nach dem Versand ab',
      cancel: 'Abbrechen',
      sending: 'Wird gesendet...',
      sendInvitation: 'Einladung senden',
      triggerLabel: 'Benutzer erneut einladen',
      invitationSent: 'Einladung erfolgreich gesendet',
    },
    acceptInvitation: {
      title: 'Organisationseinladung',
      description: 'Sie wurden eingeladen, einer Organisation beizutreten',
      organization: 'Organisation:',
      role: 'Rolle:',
      expiresOn: 'Diese Einladung läuft ab am {date}',
      question: 'Möchten Sie diese Einladung annehmen und der Organisation beitreten?',
      decline: 'Ablehnen',
      accept: 'Einladung annehmen',
      processing: 'Wird verarbeitet...',
    },
    redeemTrial: {
      title: 'Testversion einlösen',
      description: 'Lösen Sie einen Testcode für {orgName} ein',
      organization: 'Organisation',
      trialCode: 'Testcode',
      trialCodePlaceholder: '32-stelliger Testcode',
      trialCodeRequired: 'Testcode ist erforderlich',
      trialCodeInvalid: 'Testcode muss 32 alphanumerische Zeichen enthalten',
      cancel: 'Abbrechen',
      redeeming: 'Wird eingelöst...',
      redeem: 'Einlösen',
      trialRedeemedSuccessfully: 'Testversion erfolgreich eingelöst',
      noOrganizationSelected: 'Keine Organisation ausgewählt',
      failedToRedeemTrial: 'Einlösen der Testversion fehlgeschlagen.',
    },
    syncConfirmation: {
      titleFull: 'Vollständige Synchronisierung',
      titleReset: 'Zurücksetzen und vollständige Synchronisierung',
      descriptionFull: 'Sie sind dabei, eine vollständige Synchronisierung durchzuführen.',
      descriptionReset:
        'Sie sind dabei, eine destruktive Zurücksetzung und vollständige Synchronisierung durchzuführen.',
      warningReset:
        'Warnung: Dies ist eine destruktive Aktion und Daten werden vorübergehend nicht verfügbar sein.',
      warningResetOperations: 'Diese Operation wird:',
      warningResetOperation1: 'Vorhandene Daten im Ziel löschen',
      warningResetOperation2: 'Eine vollständige Synchronisierung von der Quelle durchführen',
      warningResetOperation3: 'Kann zu vorübergehender Datenunverfügbarkeit führen',
      warningFull: 'Dies synchronisiert alle Daten von der Quelle.',
      warningFullDescription:
        'Eine vollständige Synchronisierung verarbeitet alle Datensätze von der Quelle, unabhängig davon, ob sie zuvor synchronisiert wurden. Dies kann länger dauern als eine inkrementelle Synchronisierung und mehr Ressourcen verbrauchen.',
      acknowledgeReset:
        'Ich verstehe, dass dies alle vorhandenen Daten löschen und den Synchronisierungsstatus zurücksetzen wird. Ich möchte mit der Zurücksetzung und vollständigen Synchronisierung fortfahren.',
      cancel: 'Abbrechen',
      syncing: 'Wird synchronisiert...',
      startFullSync: 'Vollständige Synchronisierung starten',
      resetAndSync: 'Zurücksetzen und synchronisieren',
    },
    deleteSourceTable: {
      buttonText: 'Quelltabelle löschen',
      title: 'Quelltabelle löschen',
      description: 'Das Löschen einer Quelltabelle stoppt zukünftige Synchronisierungen.',
      confirmationLabel: 'Tabellenname',
      sourceTableDeletedSuccessfully: 'Quelltabelle erfolgreich gelöscht',
    },
    agreementAcceptance: {
      title: 'Rechtliche Vereinbarung',
      description:
        'Bitte lesen und akzeptieren Sie die Vereinbarung, um fortzufahren.',
      loading: 'Wird geladen...',
      loadError:
        'Die Vereinbarung konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
      accept: 'Akzeptieren',
      accepting: 'Akzeptieren...',
      decline: 'Ablehnen',
      declining: 'Ablehnen...',
      acceptError:
        'Die Vereinbarung konnte nicht akzeptiert werden. Bitte versuchen Sie es erneut.',
      privacyPolicyTitle: 'Datenschutzrichtlinie',
      termsOfUseTitle: 'Nutzungsbedingungen',
      scrollToAccept: 'Zum Akzeptieren nach unten scrollen',
    },
  },
  settings: {
    title: 'Einstellungen',
    description: 'Verwalten Sie Ihre Kontoeinstellungen und Präferenzen',
    profileInfo: {
      title: 'Profilinformationen',
      description:
        'Aktualisieren Sie Ihre persönlichen Informationen. Diese werden in der gesamten Anwendung angezeigt.',
    },
    fields: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      emailNote: 'E-Mail kann nicht geändert werden',
    },
    actions: {
      save: 'Änderungen speichern',
      saving: 'Wird gespeichert...',
    },
    language: {
      label: 'Sprache',
      description: 'Wählen Sie Ihre bevorzugte Sprache für die Anwendungsoberfläche.',
      english: 'Englisch',
      french: 'Französisch',
      german: 'Deutsch',
      spanish: 'Spanisch',
    },
    appearance: {
      title: 'Erscheinungsbild',
      description: 'Passen Sie das Anwendungsthema an.',
      themeLabel: 'Thema',
      themeDescription: 'Wählen Sie Hell-, Dunkel- oder Systemmodus.',
      toggleTheme: 'Thema wechseln',
      themeOptions: {
        light: 'Hell',
        dark: 'Dunkel',
        system: 'System',
      },
    },
    notifications: {
      updateSuccess: 'Profil erfolgreich aktualisiert',
      updateError: 'Profil konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
    },
    emailNotifications: {
      title: 'E-Mail-Benachrichtigungen',
      description: 'Wählen Sie, welche E-Mail-Benachrichtigungen Sie erhalten möchten.',
      save: 'Einstellungen speichern',
      saving: 'Wird gespeichert...',
      updateSuccess: 'Benachrichtigungseinstellungen erfolgreich aktualisiert',
      updateError:
        'Fehler beim Aktualisieren der Benachrichtigungseinstellungen. Bitte versuchen Sie es erneut.',
      sections: {
        general: 'Allgemein',
        billing: 'Abrechnung',
        dataMission: 'Data Mission',
        marketing: 'Marketing',
      },
      events: {
        UserInvited: {
          label: 'Organisationseinladungen',
          description:
            'Erhalten Sie eine E-Mail, wenn Sie eingeladen werden, einer Organisation beizutreten.',
        },
        TrialConsumed: {
          label: 'Testversion aktiviert',
          description:
            'Erhalten Sie eine E-Mail, wenn eine Produkttestversion aktiviert wird, einschließlich Testdauer und Enddatum.',
        },
        PaymentFailed: {
          label: 'Zahlung fehlgeschlagen',
          description: 'Erhalten Sie eine E-Mail, wenn ein Zahlungsversuch fehlschlägt.',
        },
        BillingReminder: {
          label: 'Abrechnungserinnerungen',
          description: 'Erhalten Sie Erinnerungen über bevorstehende Abrechnungen.',
        },
        PaymentMethodChanged: {
          label: 'Zahlungsmethode aktualisiert',
          description: 'Erhalten Sie eine E-Mail, wenn Ihre Zahlungsmethode aktualisiert wird.',
        },
        SubscriptionCanceled: {
          label: 'Abonnement gekündigt',
          description: 'Erhalten Sie eine E-Mail, wenn ein Abonnement gekündigt wird.',
        },
        SubscriptionSuspended: {
          label: 'Abonnement ausgesetzt',
          description:
            'Erhalten Sie eine E-Mail, wenn ein Abonnement aufgrund von Zahlungsproblemen ausgesetzt wird.',
        },
        DataMissionSyncFailed: {
          label: 'Synchronisierungsfehler',
          description:
            'Erhalten Sie eine E-Mail, wenn eine Quelltabelle in Data Mission nicht erfolgreich synchronisiert werden kann.',
        },
        ProductUpdates: {
          label: 'Produkt-Updates, Funktionen & Services',
          description: 'Bleiben Sie über neue Funktionen, Produkt-Updates und Service-Verbesserungen informiert.',
        },
        NewsTrainingArticles: {
          label: 'Neuigkeiten, Schulungen und Artikel',
          description: 'Wir senden Ihnen E-Mails mit Neuigkeiten, Schulungs-Updates und hilfreichen Artikeln über Data Mission Sync.',
        },
      },
    },
    orgSettings: {
      title: 'Organisationseinstellungen',
      description: 'Konfigurieren Sie organisationsweite Einstellungen und Standardwerte',
      organizationName: 'Name der Organisation',
      organizationNameDescription: 'Der Anzeigename dieser Organisation',
      organizationNameRequired: 'Der Name der Organisation ist erforderlich',
      billingCountry: 'Rechnungsland',
      billingCountryDescriptionSet: 'Das Rechnungsland dieser Organisation (kann nicht geändert werden)',
      billingCountryDescriptionNotSet: 'Wählen Sie das Rechnungsland dieser Organisation (kann nach der Festlegung nicht geändert werden)',
      defaultRegion: 'Standardregion',
      defaultRegionDescription: 'Die Standard-Azure-Region für neue Profile in dieser Organisation',
      noDefaultRegion: 'Keine Standardregion',
      save: 'Organisationseinstellungen speichern',
      saving: 'Wird gespeichert...',
      updateSuccess: 'Organisationseinstellungen erfolgreich aktualisiert',
      updateError: 'Fehler beim Aktualisieren der Organisationseinstellungen',
      noOrganizationSelected: 'Keine Organisation ausgewählt',
    },
    featureFlags: {
      title: 'Feature-Flags',
      description: 'Funktionen für diese Organisation aktivieren oder deaktivieren.',
    },
    legalDocuments: {
      title: 'Rechtliche Dokumente',
      description: 'Überprüfen Sie den Akzeptanzstatus unserer rechtlichen Dokumente.',
      privacyPolicy: 'Datenschutzrichtlinie',
      termsOfUse: 'Nutzungsbedingungen',
      currentVersion: 'Aktuelle Version',
      acceptedOn: 'Akzeptiert am',
      neverAccepted: 'Noch nicht akzeptiert',
      view: 'Ansehen',
      close: 'Schließen',
      version: 'Version',
    },
  },
  targets: {
    createDialog: {
      title: 'Azure SQL-Ziel erstellen',
      description: 'Eine neue Azure SQL-Zieldatenbank zu diesem Profil hinzufügen',
      addTarget: 'Ziel hinzufügen',
      onlyOneTargetTooltip:
        'Nur ein Ziel pro Profil. Löschen Sie das vorhandene Ziel, um ein neues zu erstellen.',
      targetType: 'Zieltyp',
      targetTypeDescription: 'Derzeit werden nur Azure SQL-Datenbankziele unterstützt',
      authType: 'Authentifizierungstyp',
      authTypeServicePrincipal: 'Dienstprinzipal (AAD)',
      authTypeServicePrincipalDescription:
        'Mit Azure AD-Dienstprinzipal-Anmeldedaten authentifizieren',
      authTypeSqlCredential: 'SQL-Anmeldedaten',
      authTypeSqlCredentialDescription:
        'Mit einem SQL-Benutzernamen und Passwort authentifizieren',
      useSourceClientId: 'Client-ID der Quelle verwenden',
      useSourceClientIdDescription:
        'Kopieren Sie die Client-ID aus der Quelle. Sie müssen weiterhin die Mandanten-ID und das Client-Geheimnis angeben.',
      usingClientIdFromSource: 'Client-ID aus der Quelle wird verwendet',
      tenantId: 'Mandanten-ID',
      tenantIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      tenantIdDescription: 'Die Azure AD-Mandanten-ID',
      clientId: 'Client-ID',
      clientIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      clientIdDescription: 'Die Azure AD-Anwendungs-ID (Client)',
      clientSecret: 'Client-Geheimnis',
      clientSecretPlaceholder: 'Client-Geheimnis eingeben',
      clientSecretDescription: 'Das Azure AD-Anwendungsclient-Geheimnis',
      username: 'Benutzername',
      usernamePlaceholder: 'SQL-Benutzername eingeben',
      usernameDescription: 'Der SQL Server-Anmeldebenutzername',
      password: 'Passwort',
      passwordPlaceholder: 'SQL-Passwort eingeben',
      passwordDescription: 'Das SQL Server-Anmeldepasswort',
      encryptConnection: 'Verbindung verschlüsseln',
      encryptConnectionDescription: 'Deaktivieren, wenn eine Verbindung zu einem lokalen SQL Server ohne konfiguriertes TLS hergestellt wird',
      server: 'Server',
      serverPlaceholder: 'myserver.database.windows.net',
      serverDescription: 'Azure SQL-Servername (z. B. myserver.database.windows.net)',
      database: 'Datenbank',
      databasePlaceholder: 'MeineDatenbank',
      databaseDescription: 'Name der Zieldatenbank',
      schema: 'Schema',
      schemaPlaceholder: 'dbo',
      schemaDescription: "SQL-Schemaname (Standard: 'dbo')",
      agent: 'Agent',
      agentPlaceholder: 'Agent auswählen',
      agentDescription: 'Optional einen selbst gehosteten Agenten zuweisen, um Synchronisierungsvorgänge für dieses Ziel auszuführen',
      agentNone: 'Keiner (Cloud-gehostet)',
      connectionTest: 'Verbindungstest',
      testConnection: 'Verbindung testen',
      testing: 'Wird getestet...',
      testDescription: 'Testen Sie Ihre Verbindung, bevor Sie das Ziel erstellen',
      connectionSuccessful: 'Verbindung erfolgreich',
      cancel: 'Abbrechen',
      save: 'Speichern',
      saving: 'Wird gespeichert...',
      saveAndCreateSource: 'Speichern und Quelle erstellen',
      allFieldsRequired: 'Alle Felder sind erforderlich, um die Verbindung zu testen',
      validationFailed: 'Validierung fehlgeschlagen. Bitte überprüfen Sie das Formular.',
    },
    editDialog: {
      buttonText: 'Ziel bearbeiten',
      title: 'Ziel bearbeiten',
      description: 'Zielkonfiguration aktualisieren',
      tenantId: 'Mandanten-ID',
      tenantIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      tenantIdDescription: 'Die Azure AD-Mandanten-ID',
      clientId: 'Client-ID',
      clientIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      clientIdDescription: 'Die Azure AD-Anwendungs-ID (Client)',
      clientSecret: 'Client-Geheimnis',
      clientSecretPlaceholder: 'Client-Geheimnis eingeben',
      clientSecretDescription: 'Das Azure AD-Anwendungsclient-Geheimnis',
      tenantIdRequired: 'Mandanten-ID ist erforderlich',
      clientIdRequired: 'Client-ID ist erforderlich',
      clientSecretRequired: 'Client-Geheimnis ist erforderlich',
      usernameRequired: 'Benutzername ist erforderlich',
      passwordRequired: 'Passwort ist erforderlich',
      username: 'Benutzername',
      usernamePlaceholder: 'SQL-Benutzername eingeben',
      usernameDescription: 'Der SQL Server-Anmeldebenutzername',
      password: 'Passwort',
      passwordPlaceholder: 'SQL-Passwort eingeben',
      passwordDescription: 'Das SQL Server-Anmeldepasswort',
      encryptConnection: 'Verbindung verschlüsseln',
      encryptConnectionDescription: 'Deaktivieren, wenn eine Verbindung zu einem lokalen SQL Server ohne konfiguriertes TLS hergestellt wird',
      cancel: 'Abbrechen',
      update: 'Aktualisieren',
      updateSuccess: 'Ziel erfolgreich aktualisiert',
      agent: 'Agent',
      agentPlaceholder: 'Agent auswählen',
      agentDescription: 'Einen selbst gehosteten Agenten zuweisen, um Synchronisierungsvorgänge für dieses Ziel auszuführen',
      agentNone: 'Keiner (Cloud-gehostet)',
      testConnection: 'Verbindung testen',
      connectionSuccessful: 'Verbindung erfolgreich',
    },
    prefixDialog: {
      buttonText: 'Tabellenpräfix ändern',
      title: 'Tabellenpräfix ändern',
      description: 'Das Tabellenpräfix wird auf jede Tabelle angewendet, die dieses Profil erstellt.',
      label: 'Tabellenpräfix',
      placeholder: 'z.B. dms_',
      hint: 'Nur Buchstaben, Ziffern und Unterstriche. Leer lassen für kein Präfix.',
      invalidPrefix: 'Das Tabellenpräfix darf nur Buchstaben, Ziffern und Unterstriche enthalten.',
      tablesTooLong: 'Einige Tabellen können dieses Präfix nicht verwenden, da ihr Name das SQL-Limit von 128 Zeichen überschreiten würde:',
      warningTitle: 'Dadurch werden alle synchronisierten Tabellen gelöscht und neu erstellt',
      warningOperation1: 'Alle Zieltabellen (final und Staging) für dieses Profil werden gelöscht.',
      warningOperation2: 'Sie werden mit dem neuen Präfix neu erstellt und von Grund auf neu synchronisiert.',
      warningOperation3: 'Synchronisierte Daten sind nicht verfügbar, bis die erneute Synchronisierung abgeschlossen ist.',
      acknowledge: 'Ich verstehe, dass alle synchronisierten Tabellen gelöscht und neu erstellt werden.',
      cancel: 'Abbrechen',
      apply: 'Präfix ändern',
      updateSuccess: 'Tabellenpräfix aktualisiert',
    },
    notifications: {
      createSuccess: 'Ziel erfolgreich erstellt',
      createError: 'Ziel konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    },
  },
  sources: {
    pageSizeField: {
      label: 'Seitengröße',
      description: 'Pro Extraktionsanfrage abgerufene Zeilen ({min}–{max}). Höhere Werte bedeuten weniger Aufrufe.',
    },
    createDialog: {
      title: 'Dataverse-Quelle erstellen',
      description: 'Eine neue Dataverse-Datenquelle zu diesem Profil hinzufügen',
      addSource: 'Quelle hinzufügen',
      onlyOneSourceTooltip:
        'Nur eine Quelle pro Profil. Löschen Sie die vorhandene Quelle, um eine neue zu erstellen.',
      sourceType: 'Quelltyp',
      sourceTypeDescription: 'Derzeit werden nur Microsoft Dataverse-Quellen unterstützt',
      baseUrl: 'Basis-URL',
      baseUrlPlaceholder: 'https://org.crm.dynamics.com',
      baseUrlDescription: 'Die HTTPS-URL zu Ihrem Dataverse-API-Endpunkt',
      clientId: 'Client-ID',
      clientIdPlaceholder: '00000000-0000-0000-0000-000000000000',
      clientIdDescription: 'Die Azure AD-Anwendungs-ID (Client)',
      clientSecret: 'Client-Geheimnis',
      clientSecretPlaceholder: 'Client-Geheimnis eingeben',
      clientSecretDescription: 'Das Azure AD-Anwendungsclient-Geheimnis',
      connectionTest: 'Verbindungstest',
      testConnection: 'Verbindung testen',
      testing: 'Verbindung wird getestet...',
      testDescription: 'Testen Sie Ihre Verbindung, bevor Sie die Quelle erstellen',
      connectionSuccessful: 'Verbindung erfolgreich',
      cancel: 'Abbrechen',
      save: 'Speichern',
      saving: 'Wird gespeichert...',
      saveAndCreateTarget: 'Speichern und Ziel erstellen',
      allFieldsRequired: 'Alle Felder sind erforderlich, um die Verbindung zu testen',
      validationFailed: 'Validierung fehlgeschlagen. Bitte überprüfen Sie das Formular.',
    },
    editDialog: {
      buttonText: 'Quelle bearbeiten',
      title: 'Quelle bearbeiten',
      description: 'Quellkonfiguration aktualisieren',
      baseUrl: 'Basis-URL',
      baseUrlDescription: 'Die HTTPS-URL zu Ihrem Dataverse-API-Endpunkt',
      pageSize: 'Seitengröße',
      pageSizeDescription: 'Datensätze pro Dataverse-API-Aufruf (1000–5000). Verringern Sie den Wert, wenn sehr breite Tabellen ein Timeout haben; erhöhen Sie ihn, um API-Aufrufe zu reduzieren. Standard 3000.',
      pageSizeRange: 'Die Seitengröße muss zwischen 1000 und 5000 liegen',
      clientId: 'Client-ID',
      clientIdDescription: 'Die Azure AD-Anwendungs-ID (Client)',
      clientSecret: 'Client-Geheimnis',
      clientSecretDescription: 'Das Azure AD-Anwendungsclient-Geheimnis',
      consumerKey: 'Consumer Key',
      consumerKeyDescription: 'Der Consumer Key Ihrer Salesforce Connected App',
      secret: 'Secret',
      secretDescription: 'Das Consumer Secret Ihrer Salesforce Connected App',
      baseUrlRequired: 'Basis-URL ist erforderlich',
      clientIdRequired: 'Client-ID ist erforderlich',
      clientSecretRequired: 'Client-Geheimnis ist erforderlich',
      consumerKeyRequired: 'Consumer Key ist erforderlich',
      secretRequired: 'Secret ist erforderlich',
      instanceUrlRequired: 'Instanz-URL ist erforderlich',
      tenantIdRequired: 'Mandanten-ID ist erforderlich',
      environmentRequired: 'Umgebung ist erforderlich',
      companyRequired: 'Bitte wählen Sie nach dem Testen der Verbindung ein Unternehmen aus',
      testConnection: 'Verbindung testen',
      connectionSuccessful: 'Verbindung erfolgreich',
      cancel: 'Abbrechen',
      updating: 'Wird aktualisiert...',
      update: 'Quelle aktualisieren',
      updateSuccess: 'Quelle erfolgreich aktualisiert',
    },
    sourceTablesDialog: {
      buttonText: 'Quelltabelle hinzufügen',
      title: 'Quelltabellen hinzufügen',
      description: 'Wählen Sie eine oder mehrere Tabellen aus dieser Quelle zum Synchronisieren',
      tables: 'Tabellen',
      selected: 'ausgewählt',
      selectAll: 'Alle auswählen',
      deselectAll: 'Alle abwählen',
      searchPlaceholder: 'Tabellen suchen...',
      loading: 'Tabellen werden geladen...',
      noTables: 'Keine Tabellen gefunden',
      selectAtLeastOne: 'Bitte wählen Sie mindestens eine Tabelle aus',
      cancel: 'Abbrechen',
      adding: 'Wird hinzugefügt...',
      addTables: 'Hinzufügen',
      addSuccess: 'Quelltabellen erfolgreich hinzugefügt!',
      timestampField: 'Zeitstempelfeld für inkrementelle Synchronisierung wählen',
      timestampFieldDescription: 'Feld für inkrementelle Synchronisierung',
      timestampFieldNone: 'Keines (vollständige Replikation)',
      incrementalSyncVia: 'Inkrementelle Synchronisierung über {field}',
      fullReplication: 'Vollständige Replikation (kein Zeitstempelfeld verfügbar)',
      noTimestampFieldNotice: 'Für diese Tabelle sind keine Zeitstempelspalten verfügbar. Jede Synchronisierung führt eine vollständige Replikation aller Datensätze durch.',
      nameTooLongForPrefix: 'Name zu lang für das Tabellenpräfix dieses Profils.',
    },
    tableBatch: {
      progress: '{done} von {total} werden hinzugefügt...',
      partialFailure: '{added} von {total} Tabellen wurden hinzugefügt. {failed} konnten nicht hinzugefügt werden:',
      moreTables: '(+{count} weitere)',
      syncStartFailed: '{count} Tabellen wurden hinzugefügt, aber ihre Erstsynchronisierung konnte nicht gestartet werden. Starten Sie eine Synchronisierung auf der Profilseite.',
    },
    tablePaste: {
      open: 'Tabellenliste einfügen',
      description: 'Fügen Sie logische Tabellennamen ein, einen pro Zeile oder durch Kommas getrennt. Groß- und Kleinschreibung wird ignoriert.',
      placeholder: 'account\ncontact\nmsdyn_matchingcriteria',
      resolve: 'Passende Tabellen auswählen',
      cancel: 'Abbrechen',
      emptyInput: 'Fügen Sie mindestens einen Tabellennamen ein.',
      summary: '{selected} ausgewählt, {alreadySelected} bereits ausgewählt, {alreadyAdded} bereits hinzugefügt, {notSyncable} nicht synchronisierbar, {notFound} nicht gefunden.',
      columnTable: 'Tabelle',
      columnResult: 'Ergebnis',
      columnDetails: 'Details',
      resultAlreadyAdded: 'Bereits hinzugefügt',
      alreadyAddedDetail: 'Diese Tabelle ist diesem Profil bereits hinzugefügt.',
      resultNotSyncable: 'Nicht synchronisierbar',
      resultNotFound: 'Nicht gefunden',
      didYouMean: 'Meinten Sie {name}?',
      noMatch: 'In der Quelle gibt es keine Tabelle mit diesem logischen Namen.',
      copyUnresolved: 'Nicht aufgelöste Namen kopieren',
      copySelected: 'Auswahl kopieren',
      copied: 'Kopiert',
      dismiss: 'Schließen',
    },
    sourceCapacity: {
      queuedTitle: 'Tabellen warten auf Dataverse-Kapazität',
      queuedDescription:
        '{count} Tabellen warten auf Dataverse-Kapazität (Limit: {limit} gleichzeitige Anfragen pro Umgebung). Die Synchronisierungen werden abgeschlossen, nur langsamer.',
      manyTablesHint:
        'Synchronisierungen für diese Dataverse-Umgebung führen bis zu {limit} Anfragen gleichzeitig aus. Mit {count} Tabellen werden große Synchronisierungen in die Warteschlange gestellt und dauern länger.',
      selectionHint:
        'Synchronisierungen für diese Dataverse-Umgebung führen bis zu {limit} Anfragen gleichzeitig aus. Mit {count} ausgewählten Tabellen wird die Erstsynchronisierung in die Warteschlange gestellt und dauert länger.',
      dedicatedAppNote:
        'Verwenden Sie eine App-Registrierung, die nur für Data Mission Sync bestimmt ist. Dataverse begrenzt gleichzeitige Anfragen pro App-Benutzer; eine gemeinsame Nutzung mit anderen Integrationen kann zu Drosselung führen.',
    },
    notifications: {
      createSuccess: 'Quelle erfolgreich erstellt',
      createError: 'Quelle konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    },
  },
  allRuns: {
    title: 'Alle Ausführungen',
    description: 'Alle Synchronisierungen aller Profile in Ihrer Organisation anzeigen',
    noOrganization: 'Keine Organisation ausgewählt',
    runHistory: 'Ausführungsverlauf',
    filteredResults: 'Gefilterte Ergebnisse',
    filtersActive: 'Filter aktiv',
    filter: 'Filter',
    allSyncRuns: 'Alle Synchronisierungen aller Profile',
    noRunsFound: 'Keine Synchronisierungen gefunden.',
    refresh: 'Aktualisieren',
    liveUpdates: {
      label: 'Live-Updates',
      tooltip:
        'Daten automatisch alle 5 Sekunden aktualisieren. Deaktiviert sich automatisch nach 5 Minuten.',
      autoDisabledMessage: 'Live-Updates wurden nach 5 Minuten automatisch deaktiviert.',
      reenableButton: 'Wieder aktivieren',
    },
    showSkipped: {
      label: 'Übersprungene anzeigen',
      tooltip: 'Übersprungene Ausführungen sind standardmäßig ausgeblendet. Aktivieren Sie diese Option, um sie in der Liste anzuzeigen.',
    },
    table: {
      runId: 'Ausführungs-ID',
      profile: 'Profil',
      sourceTable: 'Quelltabelle',
      scheduled: 'Geplant',
      started: 'Gestartet',
      completed: 'Abgeschlossen',
      state: 'Status',
      duration: 'Dauer',
      extractionStarted: 'Extraktion gestartet',
      extractionCompleted: 'Extraktion abgeschlossen',
      extractionDuration: 'Extraktionsdauer',
      loadStarted: 'Laden gestartet',
      loadCompleted: 'Laden abgeschlossen',
      loadDuration: 'Ladedauer',
      rowsExtracted: 'Zeilen extrahiert',
      rowsLoaded: 'Zeilen geladen',
      rowsInserted: 'Zeilen eingefügt',
      rowsUpdated: 'Zeilen aktualisiert',
      rowsDeleted: 'Zeilen gelöscht',
      rows: 'Zeilen',
      progress: 'Fortschritt',
      syncMode: 'Synchronisierungsmodus',
      triggerSource: 'Auslöser',
      region: 'Region',
      schemaChanges: 'Schema-Änderungen',
      actions: 'Aktionen',
    },
    schemaChanges: {
      title: 'Schema-Änderungen',
      columnsCreated: 'Erstellte Spalten',
      columnsWidened: 'Spaltenverbreiterung',
      failedMigrations: 'Fehlgeschlagene Migrationen',
      columnName: 'Spalte',
      sqlType: 'SQL-Typ',
      entity: 'Entität',
      fromType: 'Von',
      toType: 'Zu',
      noChanges: 'Keine Schema-Änderungen für diese Ausführung aufgezeichnet.',
      viewChanges: '{0} Änderungen anzeigen',
    },
    actions: {
      cancel: 'Abbrechen',
      cancelSuccess: 'Ausführung erfolgreich abgebrochen',
      cancelError: 'Fehler beim Abbrechen der Ausführung',
      copiedToClipboard: 'In die Zwischenablage kopiert',
      failedToCopy: 'Kopieren fehlgeschlagen',
    },
    columnToggle: {
      columnsButton: 'Spalten',
      toggleColumnsLabel: 'Spalten umschalten',
      showAllColumns: 'Alle Spalten anzeigen',
      extractionSection: 'Extraktion',
      loadSection: 'Laden',
      rows: 'Zeilen',
    },
    pagination: {
      page: 'Seite',
      showing: 'Zeige',
      runs: 'Ausführungen',
      previous: 'Zurück',
      next: 'Weiter',
    },
    errors: {
      failedToLoad: 'Ausführungen konnten nicht geladen werden',
    },
    filters: {
      filterButton: 'Filter',
      profile: 'Profil',
      runState: 'Ausführungsstatus',
      sourceTable: 'Quelltabelle',
      noProfilesAvailable: 'Keine Profile verfügbar',
      noSourceTablesAvailable: 'Keine Quelltabellen verfügbar',
      customSourceTable: 'Tabellenname eingeben...',
      clearAll: 'Alle löschen',
      unknownProfile: 'Unbekanntes Profil',
    },
  },
  help: {
    title: 'Hilfe',
    description: 'Erhalten Sie Unterstützung und finden Sie hilfreiche Ressourcen',
    additionalResources: {
      title: 'Zusätzliche Ressourcen',
      description:
        'Finden Sie Dokumentation, Anleitungen und Tutorials auf unserer Support-Website',
      content: 'Finden Sie zusätzliche Ressourcen auf der Support-Website',
      comingSoon: '(demnächst verfügbar)',
    },
    chatWithSupport: {
      title: 'Chat mit Support',
      description: 'Erhalten Sie Hilfe direkt von unserem Support-Team',
      comingSoon: 'Demnächst verfügbar',
    },
  },
  billing: {
    title: 'Abrechnung',
    description: 'Verwalten Sie Ihr Abonnement und Ihre Berechtigungen',
    redeemTrialCode: 'Testcode einlösen',
    subscribe: 'Abonnieren',
    customerPortal: 'Kundenportal',
    manageSubscription: 'Abrechnung verwalten',
    customerPortalTooltip: 'Abonnement aktualisieren, Rechnungen anzeigen und Zahlungsmethoden ändern.',
    entitlementsTable: {
      title: 'Berechtigungen',
      type: 'Typ',
      ruleType: 'Regeltyp',
      profiles: 'Profile',
      status: 'Status',
      expirationDate: 'Enddatum',
      noEntitlements: 'Keine Berechtigungen gefunden.',
      trial: 'Testversion',
      paid: 'Abonnement',
      default: 'Standard',
      active: 'Aktiv',
      expired: 'Abgelaufen',
      pastDue: 'Überfällig',
      renewal: 'Verlängerung',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
      never: 'Nie',
      renewsOn: 'Verlängert sich am {date}',
      expiresOn: 'Läuft ab am {date}',
      neverExpires: 'Läuft nie ab',
      ruleTypes: {
        minimum: 'Minimum',
        minimumTooltip: 'Diese Berechtigung gewährt mindestens {value} aktive Profile.',
        cumulative: 'Kumulativ',
        cumulativeTooltip: 'Diese Berechtigung gewährt {value} zusätzliche aktive Profile.',
      },
    },
    pastDueAlert: {
      title: 'Zahlung erforderlich',
      alertTitle: 'Zahlung überfällig',
      description: 'Die Zahlung für Ihr Abonnement ist überfällig. Bitte aktualisieren Sie Ihre Zahlungsmethode, um eine Dienstunterbrechung zu vermeiden.',
    },
    trialExpirationAlert: {
      alertTitle: 'Testversion läuft bald ab',
      description: 'Ihre Testversion läuft in {days} Tagen ab. Abonnieren Sie jetzt, um alle Funktionen weiter nutzen zu können.',
    },
    noEntitlementsAlert: {
      alertTitle: 'Abonnement erforderlich',
      description: 'Sie benötigen ein aktives Abonnement, um Profile zu synchronisieren. Abonnieren Sie jetzt, um fortzufahren.',
    },
    planPicker: {
      title: 'Plan auswählen',
      description:
        'Wählen Sie aus, wie Sie abonnieren möchten. Sie werden zum Abschluss des Kaufs zu unserem Zahlungsanbieter weitergeleitet.',
      quantity: 'Anzahl',
      total: 'Gesamt',
      perMonth: '/Monat',
      perYear: '/Jahr',
      savePercent: '{percent} % sparen',
      failedToLoad: 'Verfügbare Pläne konnten nicht geladen werden',
      noPlans: 'Für Ihre Organisation sind derzeit keine Pläne verfügbar.',
      planUnavailable:
        'Der ausgewählte Plan ist für Ihre Organisation nicht mehr verfügbar. Die verfügbaren Pläne wurden aktualisiert.',
      checkoutError: 'Der Bezahlvorgang konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
    },
    invoiceHistory: {
      title: 'Rechnungen',
      date: 'Datum',
      amount: 'Betrag',
      statusLabel: 'Status',
      actions: 'Aktionen',
      noInvoices: 'Keine Rechnungen gefunden.',
      view: 'Anzeigen',
      showing: '{count} von {total} Rechnungen angezeigt',
      previous: 'Zurück',
      next: 'Weiter',
      status: {
        draft: 'Entwurf',
        open: 'Offen',
        paid: 'Bezahlt',
        uncollectible: 'Uneinbringlich',
        void: 'Storniert',
        unknown: 'Unbekannt',
      },
    },
    orgBilling: {
      title: 'Rechnungsinformationen',
      billingAddress: 'Rechnungsadresse',
      paymentMethod: 'Zahlungsmethode',
      noAddress: 'Keine Rechnungsadresse hinterlegt',
      noPaymentMethod: 'Keine Zahlungsmethode hinterlegt',
      expires: 'Läuft ab',
      failedToLoad: 'Fehler beim Laden der Rechnungsinformationen',
      paymentMethodTypes: {
        card: 'Karte',
        acss_debit: 'Vorautorisierte Lastschrift (ACSS)',
        affirm: 'Affirm',
        afterpay_clearpay: 'Afterpay / Clearpay',
        alipay: 'Alipay',
        alma: 'Alma',
        amazon_pay: 'Amazon Pay',
        au_becs_debit: 'BECS-Lastschrift (AU)',
        bacs_debit: 'Bacs-Lastschrift',
        bancontact: 'Bancontact',
        billie: 'Billie',
        blik: 'BLIK',
        boleto: 'Boleto',
        card_present: 'Karte (vor Ort)',
        cashapp: 'Cash App Pay',
        crypto: 'Krypto',
        customer_balance: 'Kontoguthaben',
        eps: 'EPS',
        fpx: 'FPX',
        giropay: 'giropay',
        grabpay: 'GrabPay',
        ideal: 'iDEAL',
        interac_present: 'Interac',
        kakao_pay: 'Kakao Pay',
        klarna: 'Klarna',
        konbini: 'Konbini',
        kr_card: 'Koreanische Karte',
        link: 'Link',
        mb_way: 'MB WAY',
        mobilepay: 'MobilePay',
        multibanco: 'Multibanco',
        naver_pay: 'Naver Pay',
        nz_bank_account: 'NZ-Bankkonto',
        oxxo: 'OXXO',
        p24: 'Przelewy24',
        pay_by_bank: 'Per Bank bezahlen',
        payco: 'PAYCO',
        paynow: 'PayNow',
        paypal: 'PayPal',
        paypay: 'PayPay',
        payto: 'PayTo',
        pix: 'Pix',
        promptpay: 'PromptPay',
        revolut_pay: 'Revolut Pay',
        samsung_pay: 'Samsung Pay',
        satispay: 'Satispay',
        sepa_debit: 'SEPA-Lastschrift',
        sofort: 'Sofort',
        swish: 'Swish',
        twint: 'TWINT',
        us_bank_account: 'US-Bankkonto',
        wechat_pay: 'WeChat Pay',
        zip: 'Zip',
        unknown: 'Zahlungsmethode',
      },
    },
    manageAddOns: {
      title: 'Add-ons verwalten',
      description: 'Ihre Abonnement-Add-ons ändern',
      button: 'Add-ons verwalten',
      currentAddOns: 'Aktuelle Add-ons',
      availableAddOns: 'Verfügbare Add-ons',
      noCurrentAddOns: 'Sie haben keine aktiven Add-ons',
      noAvailableAddOns: 'Keine zusätzlichen Add-ons verfügbar',
      add: 'Hinzufügen',
      remove: 'Entfernen',
      perMonth: '/Monat',
      perYear: '/Jahr',
      previewChanges: 'Änderungen anzeigen',
      confirmChanges: 'Änderungen bestätigen',
      back: 'Zurück',
      noChanges: 'Keine Änderungen zur Vorschau',
      preview: {
        title: 'Änderungen überprüfen',
        description: 'Überprüfen Sie die Auswirkungen Ihrer Abonnementänderungen',
        changesSummary: 'Änderungsübersicht',
        dueToday: 'Heute fällig',
        dueTodayDescription: 'Anteilige Gebühren für den aktuellen Abrechnungszeitraum',
        nextRenewal: 'Nächste Verlängerung',
        nextRenewalDescription: 'Ihre neuen wiederkehrenden Gebühren',
        effectiveDate: 'Gültig ab',
        immediateCharge: 'Sofortige Belastung',
        newRecurringTotal: 'Neue wiederkehrende Summe',
        wasQuantity: '(war {quantity})',
        newItem: '(neu)',
        removed: '(entfernt)',
      },
      success: 'Add-ons erfolgreich aktualisiert',
      errorPreview: 'Vorschau der Änderungen fehlgeschlagen',
      errorUpdate: 'Aktualisierung der Add-ons fehlgeschlagen',
      pendingChanges: 'Ausstehende Herabstufung wird am {date} wirksam',
      cancellationScheduled: 'Ihr Abonnement ist zur Kündigung vorgemerkt. Add-ons können nicht geändert werden.',
    },
  },
  agents: {
    title: 'Agenten',
    description: 'Selbst gehostete Agenten für Ihre Organisation verwalten',
    addAgent: 'Agent hinzufügen',
    loadingAgents: 'Agenten werden geladen...',
    noAgentsFound: 'Keine Agenten gefunden. Fügen Sie einen Agenten hinzu, um zu beginnen.',
    table: {
      name: 'Name',
      status: 'Status',
      version: 'Version',
      lastHeartbeat: 'Letzter Heartbeat',
      registeredAt: 'Registriert am',
      created: 'Erstellt',
      actions: 'Aktionen',
      lastError: 'Letzter Fehler',
      viewDetails: 'Details anzeigen',
    },
    detailPage: {
      title: 'Agent-Details',
      backButton: 'Zurück zu Agenten',
      infoCard: {
        title: 'Agent-Informationen',
        status: 'Status',
        version: 'Version',
        lastHeartbeat: 'Letzter Heartbeat',
        registeredAt: 'Registriert am',
        lastError: 'Letzter Fehler',
        noError: 'Keiner',
      },
      logs: {
        title: 'Agent-Protokolle',
        level: 'Ebene',
        source: 'Quelle',
        message: 'Nachricht',
        timestamp: 'Empfangen am',
        agentTime: 'Agent:',
        noLogs: 'Keine Protokolle aufgezeichnet.',
        loadMore: 'Mehr laden',
        loading: 'Protokolle werden geladen...',
        error: 'Fehler beim Laden der Protokolle',
        showing: '{count} Einträge werden angezeigt',
      },
    },
    status: {
      Active: 'Aktiv',
      Inactive: 'Inaktiv',
      Unregistered: 'Nicht registriert',
    },
    createDialog: {
      title: 'Agent hinzufügen',
      description: 'Erstellen Sie einen neuen selbst gehosteten Agenten für Ihre Organisation',
      nameLabel: 'Agentenname',
      namePlaceholder: 'Mein Agent',
      cancel: 'Abbrechen',
      create: 'Agent erstellen',
      creating: 'Wird erstellt...',
      successTitle: 'Agent erstellt',
      successDescription: 'Ihr Agent wurde erstellt. Kopieren Sie das Registrierungstoken unten. Dieses Token wird nur einmal angezeigt.',
      registrationToken: 'Registrierungstoken',
      tokenExpires: 'Token läuft ab am',
      copyToken: 'Token kopieren',
      tokenCopied: 'Token in die Zwischenablage kopiert',
      tokenWarning: 'Dieses Token wird nur einmal angezeigt. Stellen Sie sicher, dass Sie es jetzt kopieren.',
      close: 'Schließen',
    },
    editDialog: {
      title: 'Agent bearbeiten',
      description: 'Agentennamen und parallele Aufgaben aktualisieren',
      nameLabel: 'Agentenname',
      namePlaceholder: 'Mein Agent',
      cancel: 'Abbrechen',
      save: 'Änderungen speichern',
      saving: 'Wird gespeichert...',
      success: 'Agent erfolgreich aktualisiert',
      triggerLabel: 'Agent bearbeiten',
      workerCountLabel: 'Parallele Aufgaben',
      workerCountDescription: 'Wie viele Aufgaben der Agent gleichzeitig ausführt (1–10). Wird beim nächsten Heartbeat des Agenten übernommen. Standard 4.',
      workerCountRange: 'Parallele Aufgaben müssen eine ganze Zahl zwischen 1 und 10 sein',
    },
    deleteDialog: {
      title: 'Agent löschen',
      description: 'Sind Sie sicher, dass Sie den Agenten "{name}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      cancel: 'Abbrechen',
      delete: 'Agent löschen',
      deleting: 'Wird gelöscht...',
      success: 'Agent erfolgreich gelöscht',
      triggerLabel: 'Agent löschen',
    },
    regenerateTokenDialog: {
      title: 'Registrierungstoken regenerieren',
      description: 'Generieren Sie ein neues Registrierungstoken für den Agenten "{name}". Das vorherige Token wird ungültig.',
      cancel: 'Abbrechen',
      regenerate: 'Token regenerieren',
      regenerating: 'Wird regeneriert...',
      registrationToken: 'Registrierungstoken',
      tokenExpires: 'Token läuft ab am',
      copyToken: 'Token kopieren',
      tokenCopied: 'Token in die Zwischenablage kopiert',
      tokenWarning: 'Dieses Token wird nur einmal angezeigt. Stellen Sie sicher, dass Sie es jetzt kopieren.',
      close: 'Schließen',
      triggerLabel: 'Registrierungstoken regenerieren',
    },
    toggleStatus: {
      activate: 'Aktivieren',
      deactivate: 'Deaktivieren',
      activated: 'Agent erfolgreich aktiviert',
      deactivated: 'Agent erfolgreich deaktiviert',
    },
    relativeTime: {
      justNow: 'Gerade eben',
      minutesAgo: 'vor {count}m',
      hoursAgo: 'vor {count}h',
      daysAgo: 'vor {count}T',
      never: 'Nie',
    },
    downloadLatest: 'Neuesten Agent herunterladen',
    updateAvailable: 'Agent-Update verfügbar',
    updateAvailableDescription: 'Die folgenden Agenten verwenden eine veraltete Version und sollten aktualisiert werden:',
    versionOutdated: 'Update verfügbar',
    profileAgentOutdated: 'Der diesem Profil zugewiesene Agent verwendet eine veraltete Version. Bitte aktualisieren Sie auf die neueste Version.',
    assignedAgent: 'Zugewiesener Agent',
    agentDisabled: 'Agent deaktiviert',
    agentDisabledDescription: 'Dieser Agent ist deaktiviert. Geplante Aufgaben werden in die Warteschlange gestellt und verarbeitet, wenn der Agent wieder aktiviert wird.',
    health: {
      label: 'Zustand',
      Online: 'Online',
      Suspect: 'Wird geprüft',
      Offline: 'Offline',
      offlineSince: 'Offline seit {time}',
    },
    healthCheck: {
      confirm: 'Zustand prüfen',
      started: 'Zustandsprüfung gestartet',
      checking: 'Wird geprüft…',
      potentialIssue: 'Mögliches Problem',
      likelyIssue: 'Wahrscheinliches Problem',
      healthy: 'Fehlerfrei',
      busy: 'Beschäftigt – Prüfung wartet hinter einer laufenden Aufgabe',
      unresponsive: 'Keine Antwort – als offline markiert',
      inconclusive: 'Prüfung konnte nicht abgeschlossen werden',
      lastResult: 'Letzte Zustandsprüfung',
    },
    agentOffline: {
      title: 'Synchronisierungen pausiert – Agent offline',
      profileDescription: 'Der Agent „{agent}“, der das Ziel dieses Profils lädt, ist seit {time} offline. Bis er wieder online ist, wird nichts synchronisiert; danach werden die Synchronisierungen automatisch fortgesetzt.',
      dashboardDescription: '{count} Agent(en) offline. Profile, die sie verwenden, sind pausiert, bis sie wieder online sind.',
      viewAgents: 'Agenten anzeigen',
    },
    errors: {
      failedToLoadAgents: 'Agenten konnten nicht geladen werden',
    },
  },
  organizationMembers: {
    title: 'Organisationsmitglieder',
    description: 'Mitglieder und ihre Rollen in Ihrer Organisation verwalten',
    inviteNewUser: 'Neuen Benutzer einladen',
    loadingMembers: 'Mitglieder werden geladen...',
    noMembersFound: 'Keine Mitglieder gefunden. Laden Sie Benutzer ein, um zu beginnen.',
    organizationNotFound: 'Organisation nicht gefunden',
    table: {
      email: 'E-Mail',
      role: 'Rolle',
      status: 'Status',
      joined: 'Beigetreten',
      expires: 'Läuft ab',
      actions: 'Aktionen',
    },
    roles: {
      Administrator: 'Administrator',
      Operator: 'Betreiber',
      Reader: 'Leser',
      Billing: 'Abrechnungsmanager',
    },
    status: {
      Accepted: 'Akzeptiert',
      Invited: 'Eingeladen',
      Declined: 'Abgelehnt',
      Expired: 'Abgelaufen',
    },
    indefinite: 'Unbefristet',
  },
  userContext: {
    noAccount: 'Kein Konto verfügbar',
    authRequired: 'Interaktive Authentifizierung erforderlich',
    initFailed: 'Benutzerinitialisierung fehlgeschlagen',
    loading: 'Wird geladen...',
    mustUseProvider: 'useUser muss innerhalb eines UserProvider verwendet werden',
  },
  authenticationError: {
    title: 'Authentifizierung erforderlich',
    description:
      'Ihre Sitzung ist abgelaufen oder die Authentifizierung ist fehlgeschlagen. Bitte melden Sie sich erneut an, um fortzufahren.',
    signInButton: 'Erneut anmelden',
  },
  errors: {
    common: {
      title: 'Fehler beim Laden der Daten',
      retry: 'Wiederholen',
      failedToLoad: 'Daten konnten nicht geladen werden',
      networkError: 'Netzwerkfehler - bitte überprüfen Sie Ihre Verbindung',
      serverError: 'Serverfehler - bitte versuchen Sie es später erneut',
      unauthorized: 'Authentifizierung erforderlich - bitte melden Sie sich erneut an',
      forbidden: 'Zugriff verweigert - unzureichende Berechtigungen',
      notFound: 'Ressource nicht gefunden',
      unknown: 'Ein unerwarteter Fehler ist aufgetreten',
    },
    profiles: {
      failedToLoadProfiles: 'Profile konnten nicht geladen werden',
      failedToLoadProfileDetails: 'Profildetails konnten nicht geladen werden',
      failedToLoadSchedules: 'Zeitpläne konnten nicht geladen werden',
      failedToLoadSourceTables: 'Quelltabellen konnten nicht geladen werden',
      failedToLoadRuns: 'Synchronisierungsläufe konnten nicht geladen werden',
    },
    entitlements: {
      failedToLoadEntitlements: 'Abonnementinformationen konnten nicht geladen werden',
    },
    members: {
      failedToLoadRoles: 'Organisationsrollen konnten nicht geladen werden',
      failedToLoadMembers: 'Organisationsmitglieder konnten nicht geladen werden',
    },
    codes: {
      Success: 'Der Synchronisierungsvorgang wurde erfolgreich abgeschlossen.',
      BadRequest: 'Die Anfrage war ungültig oder fehlerhaft. Bitte überprüfen Sie Ihre Konfigurationseinstellungen und versuchen Sie es erneut.',
      Unauthorized: 'Authentifizierung ist erforderlich, um diesen Vorgang durchzuführen. Bitte melden Sie sich erneut an oder überprüfen Sie Ihre Anmeldedaten.',
      Forbidden: 'Sie haben keine Berechtigung, diesen Vorgang durchzuführen. Wenden Sie sich bitte an Ihren Administrator, um Zugriff anzufordern.',
      NotFound: 'Die angeforderte Ressource konnte nicht gefunden werden. Überprüfen Sie, ob das Profil, die Quelle oder das Ziel noch existiert.',
      Conflict: 'Dieser Vorgang konfligiert mit einer vorhandenen Ressource. Eine andere Synchronisierung könnte in Bearbeitung sein oder die Ressource existiert bereits.',
      InternalServerError: 'Ein unerwarteter Serverfehler ist aufgetreten. Bitte versuchen Sie es später erneut. Falls das Problem weiterhin besteht, kontaktieren Sie den Support.',
      DatabaseError: 'Ein Datenbankvorgang ist fehlgeschlagen. Bitte überprüfen Sie Ihre Datenbankkonfiguration und versuchen Sie es erneut.',
      ServiceUnavailable: 'Der Dienst ist vorübergehend nicht verfügbar. Bitte warten Sie einige Minuten und versuchen Sie es erneut.',
      DataExtractionFailed: 'Fehler beim Extrahieren von Daten aus der Quelle. Überprüfen Sie die Quellverbindungseinstellungen und dass der service principal Lesezugriff auf die Dataverse-Entität hat.',
      SchemaExtractionFailed: 'Fehler beim Extrahieren von Schemainformationen aus der Quelle. Überprüfen Sie, dass der service principal Berechtigung hat, Entity Metadata in Dataverse zu lesen.',
      CheckpointRetrievalFailed: 'Fehler beim Abrufen von Checkpoint-Informationen zur Synchronisierung. Der Synchronisierungsstatus könnte beschädigt sein. Versuchen Sie, einen Reset & Full Sync durchzuführen, um den Synchronisierungsstatus wiederherzustellen.',
      TargetLoadFailed: 'Fehler beim Laden von Daten in die Zieldatenbank. Überprüfen Sie die Zielverbindungseinstellungen und dass der service principal Schreibberechtigungen im Zielschema hat.',
      DataTransformationFailed: 'Fehler beim Transformieren von Daten während der Synchronisierung. Die Quelldaten könnten Werte enthalten, die mit dem Zielschema nicht kompatibel sind. Überprüfen Sie die externe Fehlermeldung auf Details.',
      SourceConnectionFailed: 'Fehler beim Verbinden mit der Dataverse-Quelle. Überprüfen Sie, dass die Basis-URL, Client ID und Client Secret korrekt sind und die Anwendung in dem richtigen Tenant registriert ist.',
      TargetConnectionFailed: 'Fehler beim Verbinden mit dem Azure SQL-Ziel. Überprüfen Sie den Servernamen, Datenbanknamen und die Anmeldedaten. Stellen Sie sicher, dass die Firewall Verbindungen von Azure-Diensten zulässt.',
      RateLimitExceeded: 'Das Dataverse API Rate Limit wurde überschritten. Die Synchronisierung wird automatisch erneut versucht. Falls dies anhält, erwägen Sie, die Synchronisierungshäufigkeit zu reduzieren oder wenden Sie sich an Microsoft Support.',
      TimeoutError: 'Der Vorgang hat das Zeitlimit überschritten, bevor er abgeschlossen wurde. Dies könnte auf Netzwerkprobleme oder eine langsame Antwort von der Quelle oder dem Zielsystem hindeuten.',
      NetworkError: 'Ein Netzwerkfehler ist aufgetreten. Bitte überprüfen Sie Ihre Internetverbindung und verifizieren Sie, dass die Quelle und die Ziel-Endpunkte erreichbar sind.',
      OrchestrationTimeout: 'Der Synchronisierungsvorgang hat die maximale zulässige Ausführungszeit überschritten. Bei großen Datenmengen erwägen Sie, weniger Tabellen zu synchronisieren oder führen Sie eine Initialsynchronisierung während der Nebenzeiten durch.',
      OrchestrationCancelled: 'Die Synchronisierung wurde abgebrochen, entweder manuell oder weil das zugehörige Profil oder die Entität gelöscht wurde.',
      OrchestrationOrphaned: 'Der Synchronisierungsvorgang wurde unerwartet abgebrochen, bevor er abgeschlossen werden konnte. Bitte versuchen Sie die Synchronisierung erneut.',
      InvalidConfiguration: 'Die Profilkonfiguration ist ungültig. Bitte überprüfen Sie Ihre Quellen-, Ziel- und Tabelleneinstellungen, um sicherzustellen, dass sie vollständig und korrekt sind.',
      TargetInitialSyncConflict: 'Die Zieltabelle enthält bereits Daten aus einer vorherigen Synchronisierung. Löschen Sie entweder die vorhandenen Daten aus der Zieltabelle oder verwenden Sie Reset & Full Sync, um neu zu starten.',
      DataverseCallFailed: 'Ein Aufruf der Dataverse API ist unerwartet fehlgeschlagen. Überprüfen Sie die externe Fehlermeldung auf Details. Falls das Problem weiterhin besteht, verifizieren Sie, dass Ihre Dataverse-Umgebung ordnungsgemäß funktioniert.',
      DataverseAuthenticationFailed: 'Authentifizierung bei Dataverse ist fehlgeschlagen. Überprüfen Sie, dass Client ID und Client Secret korrekt sind, das Secret nicht abgelaufen ist und die Anwendung im Dataverse-Tenant registriert ist.',
      DataverseChangeTrackingNotEnabled: 'Change Tracking ist nicht für diese Dataverse-Entität aktiviert. Aktivieren Sie Change Tracking im Dataverse Admin Center, um inkrementelle Synchronisierungen zu ermöglichen.',
      DataverseEntityNotFound: 'Die Dataverse-Entität wurde nicht gefunden. Überprüfen Sie, dass der Entity Logical Name korrekt ist und die Entität in Ihrer Dataverse-Umgebung existiert.',
      DataversePermissionDenied: 'Der service principal hat keine Berechtigung, auf diese Dataverse-Entität zuzugreifen. Gewähren Sie der Anwendung die erforderlichen Sicherheitsrollen im Dataverse Admin Center.',
      DataverseInvalidEntityConfiguration: 'Die Dataverse-Entitätskonfiguration ist ungültig. Die Entität könnte einen Primärschlüssel vermissen oder eine nicht unterstützte Struktur haben.',
      DataverseSecretRetrievalFailed: 'Fehler beim Abrufen von Anmeldedaten aus dem sicheren Speicher. Bitte geben Sie Ihr Client Secret erneut in die Quellkonfiguration ein.',
      LockAcquisitionFailed: 'Fehler beim Erwerben einer Sperre in der Zieldatenbank. Eine andere Synchronisierung könnte in Bearbeitung sein. Warten Sie, bis die aktuelle Synchronisierung abgeschlossen ist, bevor Sie es erneut versuchen.',
      AzureSqlAuthenticationFailed: 'Authentifizierung bei Azure SQL ist fehlgeschlagen. Überprüfen Sie, dass Tenant ID, Client ID und Client Secret korrekt sind. Stellen Sie sicher, dass der service principal als Datenbankbenutzer mit entsprechenden Berechtigungen hinzugefügt wurde.',
      AzureSqlConnectionTimeout: 'Verbindung zu Azure SQL hat das Zeitlimit überschritten. Der Datenbankserver könnte unerreichbar, pausiert oder überlastet sein. Überprüfen Sie den Serverstatus im Azure Portal.',
      AzureSqlPermissionDenied: 'Der service principal hat nicht ausreichend Berechtigungen in der Azure SQL-Datenbank. Gewähren Sie dem service principal die Rollen db_datareader und db_datawriter in der Zieldatenbank.',
      AzureSqlSchemaMigrationFailed: 'Fehler beim Erstellen oder Aktualisieren des Datenbankschemas. Der service principal könnte keine Berechtigung haben, Tabellen zu erstellen, oder die Schemaänderung konfligiert mit vorhandenen Objekten.',
      AzureSqlDataImportFailed: 'Fehler beim Importieren von Daten in Azure SQL. Überprüfen Sie, dass die Datentypen kompatibel sind und der service principal Einfügungsberechtigungen in den Zieltabellen hat.',
      AzureSqlMergeFailed: 'Der Datenzusammenführungsvorgang ist fehlgeschlagen. Dies könnte auf Datentypen-Nichtübereinstimmungen, Constraint-Verletzungen oder SQL-Syntaxfehler zurückzuführen sein. Überprüfen Sie die externe Fehlermeldung auf Details.',
      AzureSqlConstraintViolation: 'Daten verletzen eine Datenbankeinschränkung (Fremdschlüssel, Eindeutigkeit oder Check Constraint). Die Quelldaten könnten ungültige Verweise oder doppelte Schlüssel enthalten.',
      AzureSqlDeadlock: 'Ein Deadlock wurde während des Synchronisierungsvorgangs erkannt. Der Vorgang wird automatisch erneut versucht. Falls dies anhält, erwägen Sie, Synchronisierungen während der Nebenzeiten zu planen.',
      AzureSqlDatabaseNotFound: 'Die angegebene Datenbank wurde auf dem Azure SQL-Server nicht gefunden. Überprüfen Sie, dass der Datenbankname korrekt ist und die Datenbank nicht gelöscht oder umbenannt wurde.',
      AzureSqlServerNotFound: 'Der Azure SQL-Server konnte nicht erreicht werden. Überprüfen Sie, dass der Servername korrekt ist, der Server existiert und die Netzwerkverbindung die Verbindung zulässt.',
      AzureSqlTransactionTimeout: 'Eine Datenbanktransaktion hat das Zeitlimit überschritten. Der Vorgang hat zu lange gedauert, möglicherweise aufgrund von Sperrungskonflikten oder Ressourceneinschränkungen. Erwägen Sie, die Datenbank hochzustufen.',
      AzureSqlInsufficientResources: 'Die Azure SQL-Datenbank hat unzureichende Ressourcen (CPU, Speicher oder DTUs), um den Vorgang abzuschließen. Erwägen Sie, auf einen höheren Service Tier hochzustufen.',
      AzureSqlSchemaMetadataNotFound: 'Erforderliche Schemametadaten wurden nicht gefunden. Dies könnte auf ein Synchronisierungszustandsproblem hindeuten. Versuchen Sie, einen Reset & Full Sync durchzuführen, um die Schemametadaten neu zu generieren.',
      AzureSqlPrimaryKeyStructureChanged: 'Die Primärschlüsselstruktur der Quellentität hat sich geändert und kann nicht auf die vorhandene Zieltabelle angewendet werden. Löschen Sie die Zieltabelle oder verwenden Sie Reset & Full Sync.',
      AzureSqlUnsafeSchemaChange: 'Die Quellschemaänderung kann nicht sicher angewendet werden. Nur das Erweitern von Spaltentypen und das Setzen von Spalten auf null-able werden unterstützt. Andere Änderungen erfordern einen Reset & Full Sync.',
      AzureSqlMergeTimeout: 'Der Datenzusammenführungsvorgang hat das Zeitlimit überschritten. Dies tritt normalerweise auf, wenn große Datenmengen in eine Low-Tier-Datenbank synchronisiert werden. Erwägen Sie, Ihren Database Tier hochzustufen oder das Datenvolumen pro Synchronisierung zu reduzieren.',
      AzureSqlFirewallBlocked: 'Verbindung blockiert durch Azure SQL-Firewall. Fügen Sie die statische Data Mission-IP ({ip}) zur Firewall-Allowlist Ihres Servers hinzu.',
      AzureSqlSchemaNotFound: 'Das angegebene Schema existiert nicht in der Zieldatenbank. Erstellen Sie das Schema in Azure SQL oder ändern Sie den Schemanamen in Ihrer Zielkonfiguration.',
      AgentTaskTimedOut: 'Der selbst gehostete Agent hat die Aufgabe nicht innerhalb des konfigurierten Zeitlimits abgeschlossen. Überprüfen Sie, ob der Agent ausgeführt wird und Netzwerkzugriff auf die Quelle und das Ziel hat.',
      AgentTaskFailed: 'Der selbst gehostete Agent hat einen Aufgabenfehler gemeldet. Stellen Sie sicher, dass die Agent-Software auf dem neuesten Stand ist, und überprüfen Sie die Agent-Protokolle auf Details.',
      UnsupportedTaskType: 'Der Agent hat einen Aufgabentyp erhalten, den er nicht unterstützt. Stellen Sie sicher, dass die Agent-Software auf dem neuesten Stand ist.',
      AgentTaskNotPickedUp: 'Der selbst gehostete Agent hat die Aufgabe nicht innerhalb von 10 Minuten gestartet, obwohl er nicht mit anderen Aufgaben beschäftigt war. Überprüfen Sie, ob der Agent-Dienst ausgeführt wird und verbunden ist.',
      SupportServiceUnavailable: 'Der Support ist vorübergehend nicht verfügbar. Bitte versuchen Sie es in einigen Minuten erneut.',
      SupportServiceMisconfigured: 'Der Support ist vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut oder kontaktieren Sie uns, wenn das Problem weiterhin besteht.',
      '40615': 'Ihre IP-Adresse ist nicht berechtigt, sich mit dem Server zu verbinden. Bitte fügen Sie diese IP zu den Azure SQL-Firewall-Regeln hinzu.',
      '-2': 'Verbindungstimeout. Der Server ist möglicherweise nicht erreichbar oder Firewall-Regeln blockieren den Zugriff.',
      '-1': 'Verbindungstimeout. Der Server ist möglicherweise nicht erreichbar oder Firewall-Regeln blockieren den Zugriff.',
      '18456': 'Anmeldung fehlgeschlagen. Bitte überprüfen Sie, ob Ihre Anmeldedaten korrekt sind und Zugriff auf die Datenbank haben.',
      '4060': 'Zugriff auf die Datenbank nicht möglich. Bitte überprüfen Sie, ob die Datenbank existiert und der Dienstprinzipal Zugriff hat.',
      '297': 'Der Dienstprinzipal hat keine Berechtigung, auf die Datenbank zuzugreifen.',
      '916': 'Der Dienstprinzipal hat keine Berechtigung, auf die Datenbank zuzugreifen.',
      '53': 'Netzwerkfehler beim Verbinden mit dem Server. Der Server ist möglicherweise nicht erreichbar oder Firewall-Regeln blockieren den Zugriff.',
      '10054': 'Netzwerkfehler beim Verbinden mit dem Server. Der Server ist möglicherweise nicht erreichbar oder Firewall-Regeln blockieren den Zugriff.',
      '10060': 'Netzwerkfehler beim Verbinden mit dem Server. Der Server ist möglicherweise nicht erreichbar oder Firewall-Regeln blockieren den Zugriff.',
      '10061': 'Netzwerkfehler beim Verbinden mit dem Server. Der Server ist möglicherweise nicht erreichbar oder Firewall-Regeln blockieren den Zugriff.',
      '20': 'Die Instanz ist nicht konfiguriert, Verbindungen zu akzeptieren. Bitte überprüfen Sie den Servernamen und die Verbindung.',
      '1202': 'Verbindung zum Ziel fehlgeschlagen. Der Azure SQL-Server konnte nicht erreicht werden. Bitte überprüfen Sie Ihre Verbindungseinstellungen.',
      '1501': 'Authentifizierung fehlgeschlagen. Bitte überprüfen Sie, ob Ihre Mandanten-ID, Client-ID und Ihr Client-Geheimnis korrekt sind und der Dienstprinzipal Zugriff auf die Datenbank hat.',
      '1502': 'Verbindungstimeout. Der Azure SQL-Server ist möglicherweise nicht erreichbar oder stark ausgelastet.',
      '1503': 'Der Dienstprinzipal hat nicht ausreichende SQL-Berechtigungen für Synchronisierungsvorgänge. Bitte gewähren Sie die erforderlichen Berechtigungen.',
      '1509': 'Datenbank nicht gefunden. Bitte überprüfen Sie, ob der Datenbankname existiert und der Dienstprinzipal Zugriff hat.',
      '1510': 'Server nicht gefunden oder Netzwerkfehler. Bitte überprüfen Sie den Azure SQL-Servernamen und die Netzwerkverbindung.',
      '1517': 'Verbindung durch Firewall blockiert. Bitte konfigurieren Sie die Firewall Ihres Azure SQL-Servers, um entweder Azure-Dienste zuzulassen oder die IP-Adressen für Azures Canada Central und Ihre ausgewählte Profilregion hinzuzufügen.',
      '1518': 'Schema nicht gefunden. Das angegebene Schema existiert nicht in der Datenbank. Bitte überprüfen Sie den Schemanamen oder erstellen Sie es.',
      DataverseHostnameNotFound: 'Der Dataverse-Hostname konnte nicht aufgelöst werden. Bitte überprüfen Sie, ob die Basis-URL korrekt ist und die Organisation existiert.',
      DataverseInvalidUrl: 'Ungültiges Format der Dataverse-Organisations-URL. Bitte überprüfen Sie, ob die Basis-URL eine gültige HTTPS-URL ist.',
      DataverseInvalidClientId: 'Ungültige Client-ID. Der Anwendungsbezeichner wird nicht erkannt. Bitte überprüfen Sie Ihre Azure AD-Anwendungsregistrierung.',
      DataverseInvalidClientSecret: 'Ungültiges Client-Geheimnis. Das Client-Geheimnis ist falsch oder abgelaufen. Bitte überprüfen oder regenerieren Sie Ihr Client-Geheimnis.',
      DataverseInvalidAppRegistration: 'Ungültige Anwendungsregistrierung. Die Anwendung hat keinen Zugriff auf diese Dataverse-Instanz oder ist nicht im Mandanten registriert.',
      DataverseInvalidTenant: 'Authentifizierungsmandant konnte nicht aus der Dataverse-URL bestimmt werden. Bitte überprüfen Sie, ob das Format der Basis-URL korrekt ist.',
      DataverseConnectionFailed: 'Verbindung zur Dataverse-Instanz fehlgeschlagen. Bitte überprüfen Sie, ob die Basis-URL korrekt ist und die Instanz erreichbar ist.',
      DataversePermissionDeniedMetadata: 'Fehlende Berechtigung zum Lesen von Entitätsmetadaten. Der Dienstprinzipal kann keine Schemainformationen aus Dataverse abrufen.',
      DataversePermissionDeniedData: 'Fehlende Berechtigung zum Lesen von Entitätsdaten. Der Dienstprinzipal kann keine Datensätze aus Dataverse-Entitäten lesen.',
      DataverseVersionStampExpired: 'Die Tabelle wurde zu lange nicht synchronisiert und der inkrementelle Synchronisierungszustand ist abgelaufen. Ein Reset & Full Sync ist erforderlich, um die Synchronisierung fortzusetzen.',
      DataverseInvalidRequest: 'Beim Lesen von Daten aus Dataverse ist ein Fehler aufgetreten. Überprüfen Sie die externe Fehlermeldung auf Details. Falls das Problem weiterhin besteht, überprüfen Sie Ihre Entitätskonfiguration und Berechtigungen.',
      BcCallFailed: 'Ein Aufruf der Business Central API ist unerwartet fehlgeschlagen. Überprüfen Sie die externe Fehlermeldung für Details. Wenn das Problem weiterhin besteht, überprüfen Sie, ob Ihre Business Central-Umgebung ordnungsgemäß funktioniert.',
      BcAuthenticationFailed: 'Authentifizierung bei Business Central ist fehlgeschlagen. Überprüfen Sie, dass Client ID und Client Secret korrekt sind, das Secret nicht abgelaufen ist und die Anwendung im richtigen Mandanten registriert ist.',
      BcInvalidClientId: 'Ungültige Client-ID. Der Anwendungsbezeichner wird in Azure AD nicht erkannt. Bitte überprüfen Sie Ihre Anwendungsregistrierung.',
      BcInvalidClientSecret: 'Ungültiges Client Secret. Das Client Secret ist falsch oder abgelaufen. Bitte überprüfen oder regenerieren Sie Ihr Client Secret.',
      BcEnvironmentNotFound: 'Die Business Central-Umgebung wurde nicht gefunden. Überprüfen Sie, ob der Umgebungsname korrekt ist und die Umgebung in Ihrem Mandanten existiert.',
      BcCompanyNotFound: 'Das Business Central-Unternehmen wurde nicht gefunden. Überprüfen Sie, ob die Unternehmens-ID oder der Unternehmensname korrekt ist und das Unternehmen in der ausgewählten Umgebung existiert.',
      BcPermissionDenied: 'Der Dienstprinzipal hat keine Berechtigung zum Zugriff auf Business Central. Stellen Sie sicher, dass die Anwendung die erforderlichen API-Berechtigungen hat und im Mandanten genehmigt ist.',
      BcEntityNotFound: 'Die Business Central-Entität oder API-Seite wurde nicht gefunden. Überprüfen Sie, ob der Entitätsname korrekt ist und die API-Seite in Business Central veröffentlicht ist.',
      BcNotFound: 'Business Central hat gemeldet, dass eine angeforderte Ressource nicht gefunden wurde, aber nicht angegeben, ob die fehlende Ressource die Umgebung, das Unternehmen, die Entität oder der Datensatz war. Prüfen Sie die externen Fehlerdetails für die genaue Anforderung.',
      BcInvalidRequest: 'Business Central hat die Anfrage abgelehnt. Überprüfen Sie die externe Fehlermeldung für Details darüber, welches Feld oder welcher Parameter ungültig ist.',
      BcTenantUnavailable: 'Der Business Central-Mandant ist derzeit nicht verfügbar. Die Umgebung befindet sich möglicherweise in Wartung oder Migration. Bitte versuchen Sie es später erneut.',
      // Salesforce-Fehlercodes
      SalesforceCallFailed:
        'Ein Salesforce-API-Aufruf ist unerwartet fehlgeschlagen. Überprüfen Sie die Fehlerdetails. Wenn das Problem weiterhin besteht, stellen Sie sicher, dass Ihre Salesforce-Umgebung ordnungsgemäß funktioniert.',
      SalesforceAuthenticationFailed:
        'Die Authentifizierung bei Salesforce ist fehlgeschlagen. Überprüfen Sie die Instanz-URL, Client-ID und das Client-Secret sowie ob die Connected App aktiv ist.',
      SalesforceTokenRequestFailed:
        'Fehler beim Abrufen eines Salesforce-Zugriffstokens. Überprüfen Sie die Instanz-URL und stellen Sie sicher, dass die Connected App für den Client Credentials Flow konfiguriert ist.',
      SalesforceInvalidClientCredentials:
        'Die Salesforce Client-ID oder das Client-Secret ist ungültig. Überprüfen Sie Consumer Key und Consumer Secret Ihrer Connected App.',
      SalesforceInstanceUrlInvalid:
        'Die Salesforce-Instanz-URL ist ungültig oder nicht erreichbar. Überprüfen Sie, ob die URL eine gültige Salesforce-Org-URL ist (z. B. https://meinunternehmen.my.salesforce.com).',
      SalesforceRateLimitExceeded:
        'Das Salesforce-API-Ratenlimit wurde überschritten. Die Synchronisierung wird automatisch wiederholt. Wenn das Problem weiterhin besteht, reduzieren Sie ggf. die Synchronisierungshäufigkeit.',
      SalesforceBulkApiUnavailable:
        'Die Salesforce Bulk API 2.0 ist für diese Org nicht verfügbar. Stellen Sie sicher, dass die Connected App die erforderlichen OAuth-Scopes besitzt und der Benutzer die Berechtigung "API Enabled" hat.',
      SalesforceBulkJobFailed:
        'Der Salesforce Bulk-Query-Job ist fehlgeschlagen. Überprüfen Sie die Fehlerdetails sowie ob das Objekt abfragbar ist und der Benutzer Lesezugriff hat.',
      SalesforceBulkJobTimedOut:
        'Der Salesforce Bulk-Query-Job hat die Zeitüberschreitung erreicht. Das Objekt enthält möglicherweise sehr viele Datensätze. Reduzieren Sie ggf. die Anzahl synchronisierter Felder.',
      SalesforceEntityNotFound:
        'Das Salesforce-Objekt (SObject) wurde nicht gefunden. Überprüfen Sie den API-Namen und stellen Sie sicher, dass das Objekt in Ihrer Org existiert.',
      SalesforceApiScopeNotGranted:
        'Das Salesforce-Token hat keinen API-Zugriff. Stellen Sie sicher, dass die Connected App den OAuth-Scope "api" enthält und der Benutzer die Systemberechtigung "API Enabled" besitzt.',
      SalesforceClientCredentialsNotConfigured:
        'Der Client Credentials Flow ist für diese Connected App nicht konfiguriert. Gehen Sie in Salesforce Setup zu App Manager → Richtlinien bearbeiten → Client Credentials Flow und weisen Sie einen Benutzer zu.',
      SalesforceClientIdNotRecognized:
        'Die Salesforce Client-ID (Consumer Key) wird nicht erkannt. Überprüfen Sie, ob die Instanz-URL zur Org passt, in der die Connected App installiert ist, und ob die App aktiv ist.',
      unknown: 'Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.',
    },
  },
  systemNotices: {
    title: 'Systemhinweise',
    noNotices: 'Keine aktiven Hinweise',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    acknowledge: 'Bestätigen',
    acknowledgeForOrg: 'Für Organisation bestätigen',
    acknowledgedSuccessfully: 'Hinweis erfolgreich bestätigt',
    noPermissionToAcknowledge: 'Sie haben keine Berechtigung, diesen Hinweis zu bestätigen',
    failedToLoad: 'Systemhinweise konnten nicht geladen werden',
  },
};
